import React, { useState, useRef, useEffect, useContext } from "react";
import BannerSection from "../../inc/BannerSection";
import Banner from "../../images/banner.jpg";
import { Link, useLocation } from "react-router-dom";
import TherapistSidebar from "../../inc/TherapistSidebar";
import ConversationIcon from "../../images/conversation.svg";
import { FaStopCircle } from "react-icons/fa";
import ApiService from "../../../utility/services/ApiService";
import Functions from "../../../utility/services/Functions";
import { AuthContext } from "../../../utility/services/AuthContext";
import debugLog from "../../../utility/services/debugLog";
import ConstConfig from "../../../utility/configs/constConfig";
import { toast } from "react-toastify";
import VoiceCallScreen from "../../common/VoiceCallScreen";
import UserAvatar from "../../common/UserAvatar";
import heic2any from "heic2any";

import {
  FaPaperPlane,
  FaPhoneAlt,
  FaVideo,
  FaPaperclip,
  FaChevronCircleLeft,
  FaAlignLeft,
  FaTrashAlt,
  FaVideoSlash,
} from "react-icons/fa";
import ReactLoader from "react-js-loader";
import AgoraRTC from "agora-rtc-sdk-ng";
import ImageConfig from "../../../utility/configs/imageConfig";
import VideocamOutlinedIcon from "@mui/icons-material/VideocamOutlined";
import ImageIcon from "@mui/icons-material/Image";
import { Badge, Button, Image } from "react-bootstrap";
import { ReactIdleContext } from "../../common/components/ReactIdle";

// Enhanced Video UI Components
import Draggable from "react-draggable";
import { ResizableBox } from "react-resizable";
import "react-resizable/css/styles.css";
import {
  IconButton,
  Tooltip,
  Box,
  Paper,
  Slider,
  Typography,
  Chip,
} from "@mui/material";
import {
  Mic,
  MicOff,
  Videocam,
  VideocamOff,
  CallEnd,
  Settings,
  SignalCellularAlt,
  SignalCellular1Bar,
  SignalCellular0Bar,
  PictureInPictureAlt,
} from "@mui/icons-material";
/*eslint eqeqeq: "off"*/

// Singleton pattern to prevent multiple Agora instances (memory leak fix)
let agoraEngine = null;
const getAgoraEngine = () => {
  if (!agoraEngine) {
    agoraEngine = AgoraRTC.createClient({ mode: "rtc", codec: "vp8" });
  }
  return agoraEngine;
};

// let options = {
//   // Pass your App ID here.
//   appId: null,
//   // Set the channel name.
//   channel: `Channel ${new Date().getTime()}`,
//   // Pass your temp token here.
//   token: null,
//   // Set the user ID.
//   uid: 0,
// };

// let channelParameters = {
//   // A variable to hold a local audio track.
//   localAudioTrack: null,
//   // A variable to hold a remote audio track.
//   localVideoTrack: null,

//   remoteAudioTrack: null,
//   // A variable to hold the remote user id.
//   remoteVideoTrack: null,

//   remoteUid: null,
// };

const Chat = () => {
  // LOGICAL VARIABLES

  // Common busy message for multi-device call handling
  const BUSY_SESSION_MESSAGE =
    "A session is already in progress. Please disconnect the current session if you want to switch devices and rejoin.";

  const scroll = useRef(null);
  const users_scroll = useRef(null);
  const call_accepted = useRef(null);
  const agoraListenersAttached = useRef(false);

  // Create local refs for tracks since channelParameters from context doesn't update properly
  const localTracksRef = useRef({
    localAudioTrack: null,
    localVideoTrack: null,
  });

  // Create remote refs for tracks since channelParameters from context doesn't update properly
  const remoteTracksRef = useRef({
    remoteAudioTrack: null,
    remoteVideoTrack: null,
  });

  // Ref for isCallMinimized to avoid stale closure in Agora event handlers
  const isCallMinimizedRef = useRef(false);

  // Ref to store session timeout to prevent duplicate toasts
  const sessionTimeoutRef = useRef(null);

  // Refs for video containers
  const localVideoRef1 = useRef(null);
  const localVideoRef2 = useRef(null);

  const location = useLocation();

  const [focus, setFocus] = useState(false);
  const [filterHideShow, setfilterHideShow] = useState(false);
  const [window_class, setWindowClass] = useState("hideShow");
  const show_select_conversation_div = window_class == "hideShow";
  const [scrollPosition, setScrollPosition] = useState(
    scroll.current?.scrollHeight
  );
  const [total_chat_users, setTotalChatUsers] = useState(0);
  const [all_chat_user_loaded, setAllChatUserLoaded] = useState(false);
  const [chatLoading, setChatLoading] = useState(false);
  const [userLoading, setUserLoading] = useState(false);
  const [send_message_loading, setSendMessageLoading] = useState(false);

  const [chat_start_time, setChatStartTime] = useState("");
  const [chat_end_time, setChartEndTime] = useState("");
  const [showMessage, setShowMessage] = useState("");
  const [receivingCall, setReceiving] = useState(false);
  const [sendingCall, setSendingCall] = useState(false);
  const [callType, setCallType] = useState("");
  const [call_by_id, setCallById] = useState(null);
  const [call_to_id, setCallToId] = useState(null);
  const [callDetails, setCallDetails] = useState({});

  const [acceptCallStatus, seAcceptCallStatus] = useState(false);
  const [bySubmitMessage, setBySubmitMessage] = useState(false);
  const [callLoading, setCallLoading] = useState(false);
  const [videoCallLoading, setVideoCallLoading] = useState(false);
  const disable_call_button = videoCallLoading || callLoading;
  // NOTE: callDuration is now tracked globally in AuthContext ref (no re-renders)
  // const [callDuration, setCallDuration] = useState(0); // REMOVED - use getCallDuration()
  // const [interVal, setInterVal] = useState(null); // REMOVED - timer is global now
  const [initial_loading, setInitialLoading] = useState(false);
  const [mute_audio, setMuteAudio] = useState(false);
  const [hide_video, setHideVideo] = useState(false);
  const [forceRenderKey, setForceRenderKey] = useState(0); // Force UI re-render after PiP expand

  // NEW: Button loading states
  const [isMuteLoading, setIsMuteLoading] = useState(false);
  const [isVideoLoading, setIsVideoLoading] = useState(false);

  // Enhanced Video UI States

  // Network Quality States
  const [networkQuality, setNetworkQuality] = useState({
    uplink: 0, // 0 = unknown, 1 = excellent, 2 = good, 3 = poor, 4 = bad, 5 = very bad, 6 = no connection
    downlink: 0,
  });
  const [isNetworkPoor, setIsNetworkPoor] = useState(false);
  const [showNetworkWarning, setShowNetworkWarning] = useState(false);

  // Responsive initial size based on device
  const isMobile = window.innerWidth <= 768;
  const initialWidth = isMobile ? 108 : 252; // 10% smaller than original
  const initialHeight = (initialWidth * 3) / 4; // Maintain 4:3 ratio

  const [localVideoSize, setLocalVideoSize] = useState({
    width: initialWidth,
    height: initialHeight,
  });
  const [localVideoPosition, setLocalVideoPosition] = useState({ x: 0, y: 0 });

  const [isCallInProcess, setIsCallInProcess] = useState(false);

  // Multi-tab call coordination states
  const [remoteUserId, setRemoteUserId] = useState(null); // Store remote user ID for ending calls
  const [activeCallTabId, setActiveCallTabId] = useState(null); // Track which tab has active call
  const [isEndingCall, setIsEndingCall] = useState(false); // Prevent duplicate end messages

  const isDisableVideoCallIcon = disable_call_button || isCallInProcess;
  const isDisableDeleteChatIcon = isCallInProcess || send_message_loading;
  const isDisableAudioCallIcon = disable_call_button || isCallInProcess;

  const {
    get_chat_history,
    fetch_communicated_client_list,
    fetch_total_chat_users,
    get_upcoming_appointment_of_specific_user,
    get_agora_token,
    delete_chat,
    get_upcoming_appointment_of_specific_user_for_patient,
  } = ApiService();
  const {
    consoleService,
    get_chat_time,
    get_upcoming_timp_diff,
    checkActiveTimeSlots,
    formatCallDuration,
    getConversationTime,
    setRunningCallId,
    get_running_call_id,
  } = Functions();

  const {
    user,
    agoraMessage,
    setAgoraMessage,
    agoraNewMessage,
    socket,
    setAcceptThroughPopup,
    acceptThroughPopup,
    selectedChat_user,
    setLoading,
    authUserRole,
    selectedUser,
    setSelectedUser,
    agoraAppId,
    receive_call_audio,
    pauseAudio,
    audioChannel,
    options,
    channelParameters,
    isInCall,
    setIsInCall,
    isCallMinimized,
    setIsCallMinimized,
    callMetadata,
    setCallMetadata,
    endCallFunctionRef,
    minimizeFunctionRef,

    // NEW: Unified call state
    unifiedCallState,
    updateCallState,
    resetCallState,
    getCallDuration,
  } = useContext(AuthContext);

  options.appId = agoraAppId;
  const { start, pause } = useContext(ReactIdleContext);
  const [chatPage, setChatPage] = useState(1);
  const isAgoraMessageFound = Object.keys(agoraMessage).length > 0;
  const IsTherapist = authUserRole == "Therapist";

  // Generate unique tab ID to identify this tab
  const [tabId] = useState(
    () => `tab_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`
  );

  // Keep ref in sync with state
  useEffect(() => {
    isCallMinimizedRef.current = isCallMinimized;
  }, [isCallMinimized]);

  // BroadcastChannel listener for multi-tab call coordination
  useEffect(() => {
    if (!audioChannel) return;

    const handleBroadcastMessage = (event) => {
      const { type, tabId: senderTabId, payload } = event.data;

      // Ignore messages from this tab
      if (senderTabId === tabId) {
        return;
      }

      switch (type) {
        case "call_accepted_by_tab":
          // Another tab accepted the call
          // Additional safety check: don't cleanup if we're the active tab
          if (activeCallTabId === tabId) {
            // This is us - we accepted the call, ignore our own broadcast
            return;
          }

          setActiveCallTabId(senderTabId);
          if (payload?.remoteUserId) {
            setRemoteUserId(payload.remoteUserId);
          }
          toast.info("Call is active in another window", {
            toastId: "call-active-other-tab",
            autoClose: 3000,
          });
          // Clean up local call state but DON'T clear activeCallTabId
          if (receivingCall || sendingCall) {
            setSendingCall(false);
            setReceiving(false);
            seAcceptCallStatus(false);
            setIsCallInProcess(false);
            setCallLoading(false);
            setVideoCallLoading(false);
            pauseAudio();

            // Cleanup any partial Agora initialization
            try {
              const engine = getAgoraEngine();
              if (engine) {
                // Stop and close any tracks that might have been created
                if (channelParameters.localAudioTrack) {
                  channelParameters.localAudioTrack.stop();
                  channelParameters.localAudioTrack.close();
                  channelParameters.localAudioTrack = null;
                }
                if (channelParameters.localVideoTrack) {
                  channelParameters.localVideoTrack.stop();
                  channelParameters.localVideoTrack.close();
                  channelParameters.localVideoTrack = null;
                }
                if (localTracksRef.current.localAudioTrack) {
                  localTracksRef.current.localAudioTrack.stop();
                  localTracksRef.current.localAudioTrack.close();
                  localTracksRef.current.localAudioTrack = null;
                }
                if (localTracksRef.current.localVideoTrack) {
                  localTracksRef.current.localVideoTrack.stop();
                  localTracksRef.current.localVideoTrack.close();
                  localTracksRef.current.localVideoTrack = null;
                }
                // Leave the channel if partially joined
                engine.leave().catch(() => {});
              }
            } catch (err) {}
          }
          break;

        case "call_ended_by_tab":
          // Another tab ended the call - just cleanup locally
          if (
            !isEndingCall &&
            (receivingCall || sendingCall || acceptCallStatus)
          ) {
            setRemoteUserId(null);
            setActiveCallTabId(null);
            end_call_fun();
            pauseAudio();
          }
          break;

        case "request_call_status":
          // New tab is asking if there's an active call
          if (acceptCallStatus && remoteUserId) {
            audioChannel.postMessage({
              type: "call_status_response",
              tabId: tabId,
              payload: {
                hasActiveCall: true,
                remoteUserId: remoteUserId,
                callType: callType,
                sendingCall: sendingCall,
                receivingCall: receivingCall,
              },
            });
          }
          break;

        case "call_status_response":
          // Another tab has an active call - sync state
          // BUT: Don't sync if WE already have the active call (don't overwrite our own state)
          if (activeCallTabId === tabId) {
            return;
          }

          if (payload?.hasActiveCall && payload?.remoteUserId) {
            setActiveCallTabId(senderTabId);
            setRemoteUserId(payload.remoteUserId);
            setCallType(payload.callType);
          }
          break;

        default:
          break;
      }
    };

    audioChannel.addEventListener("message", handleBroadcastMessage);
    return () => {
      audioChannel.removeEventListener("message", handleBroadcastMessage);
    };
  }, [
    tabId,
    receivingCall,
    sendingCall,
    acceptCallStatus,
    remoteUserId,
    callType,
    isEndingCall,
    audioChannel,
    activeCallTabId,
  ]);

  // Request call status from other tabs on mount (for late-joining tabs)
  useEffect(() => {
    if (!audioChannel) return;

    // Broadcast request immediately (no delay to prevent race conditions)
    audioChannel.postMessage({
      type: "request_call_status",
      tabId: tabId,
    });
  }, [tabId, audioChannel]);

  // Add custom styles for invisible resize handles with cursor changes
  useEffect(() => {
    const style = document.createElement("style");
    style.textContent = `
      /* Make resize handles invisible but functional */
      .react-resizable-handle {
        background-color: transparent !important;
        border: none !important;
        width: ${isMobile ? "20px" : "15px"} !important;
        height: ${isMobile ? "20px" : "15px"} !important;
        z-index: 30 !important;
      }

      /* Cursor styles for each handle */
      .react-resizable-handle-se {
        cursor: nwse-resize !important;
        bottom: 0 !important;
        right: 0 !important;
      }
      .react-resizable-handle-sw {
        cursor: nesw-resize !important;
        bottom: 0 !important;
        left: 0 !important;
      }
      .react-resizable-handle-ne {
        cursor: nesw-resize !important;
        top: 0 !important;
        right: 0 !important;
      }
      .react-resizable-handle-nw {
        cursor: nwse-resize !important;
        top: 0 !important;
        left: 0 !important;
      }

      /* Professional video container styling */
      .professional-video-container {
        position: relative;
        background: linear-gradient(135deg, rgba(0,0,0,0.8) 0%, rgba(0,0,0,0.6) 100%);
        border: 1px solid rgba(255, 255, 255, 0.1);
        backdrop-filter: blur(20px);
        -webkit-backdrop-filter: blur(20px);
        animation: fadeIn 0.3s ease-in-out;
      }

      @keyframes fadeIn {
        from { opacity: 0; transform: scale(0.95); }
        to { opacity: 1; transform: scale(1); }
      }

      @keyframes gradientShift {
        0% { background-position: 0% 50%; }
        50% { background-position: 100% 50%; }
        100% { background-position: 0% 50%; }
      }

      /* Edge detection hover areas */
      .resize-edge-detector {
        position: absolute;
        pointer-events: auto;
      }
      .resize-edge-top {
        top: 0;
        left: 10px;
        right: 10px;
        height: 5px;
        cursor: ns-resize;
      }
      .resize-edge-bottom {
        bottom: 0;
        left: 10px;
        right: 10px;
        height: 5px;
        cursor: ns-resize;
      }
      .resize-edge-left {
        left: 0;
        top: 10px;
        bottom: 10px;
        width: 5px;
        cursor: ew-resize;
      }
      .resize-edge-right {
        right: 0;
        top: 10px;
        bottom: 10px;
        width: 5px;
        cursor: ew-resize;
      }
    `;
    document.head.appendChild(style);

    return () => {
      document.head.removeChild(style);
    };
  }, [isMobile]);

  // Update video element sizes when container resizes
  // Must be AFTER channelParameters is available from context
  useEffect(() => {
    // Update both video containers
    [localVideoRef1.current, localVideoRef2.current].forEach((videoElement) => {
      if (videoElement) {
        videoElement.style.width = `${localVideoSize.width}px`;
        videoElement.style.height = `${localVideoSize.height}px`;

        // If there's an active video track, re-apply it to maintain proper sizing
        const activeTrack =
          localTracksRef.current.localVideoTrack ||
          channelParameters?.localVideoTrack;
        if (activeTrack && videoElement.id) {
          try {
            activeTrack.play(videoElement.id);
          } catch (error) {}
        }
      }
    });
  }, [localVideoSize, channelParameters?.localVideoTrack]);

  // Waiting room messages
  const WAITING_ROOM_MESSAGE =
    authUserRole === "Patient"
      ? "Calling your therapist now. Please wait, your therapist will join shortly."
      : "Calling your patient now. Please wait, your client will join shortly.";

  // Welcome message for empty chat
  const WELCOME_MESSAGE =
    authUserRole === "Patient"
      ? "Welcome to the chatroom. You can chat with your therapist here. You can also tap the video or audio icons to call your therapist."
      : "Welcome to the chatroom. You can chat with your client here. You can also tap the video or audio icons to call your client.";

  const userDetails = user.details;
  const isAudioCall = callType == "audio";
  const isVideoCall = callType == "video";

  const isChatDisableCondition =
    chat_start_time &&
    chat_end_time &&
    !isTimeDisabled({
      time: chat_start_time,
      end_time: chat_end_time,
    });

  ///////////////////////////////////////// DATA VARIABLES //////////////////////////////////////////////

  const [chat_id, setChat_id] = useState(location?.state?.chat_id || "");

  const navigateFrom = location?.state?.navigateFrom || "";
  const preselectedUser = location?.state?.data || {};

  // NEW: Store appointment data for session expiry tracking
  // Accept from either 'appointment' (from App.js PiP expand) or 'data' (from Dashboard)
  const [appointmentData, setAppointmentData] = useState(
    location?.state?.appointment || location?.state?.data || null
  );

  const [users, setUsers] = useState([]);
  const [messages, setMessages] = useState([]);
  const [endCallMessage, setEndCallMessage] = useState("");
  const [message, setMessage] = useState("");
  const chatRef = useRef(null);
  const usersRef = useRef(users);
  const endCallCounterRef = useRef(null);

  /////////////////////////////////////////// USE EFFECTS ///////////////////////////////////////////

  useEffect(() => {
    try {
      chatRef.current = chat_id;

      (async function () {
        try {
          if (Object.keys(agoraMessage).length > 0) {
            const chat_id = chatRef.current;
            const data = agoraMessage;
            const user_id = userDetails._id;

            // DEBUG: Log ALL socket messages

            if (
              (data.from == user_id && data.to == chat_id) ||
              (data.from == chat_id && data.to == user_id)
            ) {
              // ============================================================================
              // 🆕 NEW: Handle call answered on another device (RECEIVER side)
              // This prevents this device from showing call UI when another device accepted
              // ============================================================================
              if (data.message_event_type == "call_answered_elsewhere") {
                handle_call_answered_elsewhere(data);
                return; // Exit early - don't show call UI on this device
              }
              // ============================================================================

              // ============================================================================
              // 🆕 NEW: Handle call connected on another device (CALLER side)
              // This prevents caller's other devices from showing call UI when call connects
              // ============================================================================
              if (data.message_event_type == "call_connected_elsewhere") {
                handle_call_answered_elsewhere(data); // Use same handler - same behavior
                return; // Exit early - don't show call UI on this device
              }
              // ============================================================================

              if (data.type == "voice_call") {
                if (data.message_event_type == "end_voice_call") {
                  debugLog("Socket_EndVoiceCall", {
                    from: data.from,
                    to: data.to,
                    currentStates: {
                      isInCall,
                      sendingCall,
                      receivingCall,
                      isCallMinimized,
                    },
                  });

                  setIsCallInProcess(false);
                  setIsInCall(false);
                  setIsCallMinimized(false);
                  setCallById(null);
                  setCallToId(null);
                  setRemoteUserId(null); // Clear remote user ID
                  setActiveCallTabId(null); // Clear active tab
                  start();
                  end_call_fun();
                  pauseAudio();
                  set_socket_message(data, user_id);
                } else if (data.message_event_type == "accepted_voice_call") {
                  debugLog("Socket_AcceptedVoiceCall", {
                    from: data.from,
                    to: data.to,
                    isOutgoing: data.to == user_id,
                    currentStates: {
                      isInCall,
                      sendingCall,
                      receivingCall,
                      isCallMinimized,
                    },
                  });

                  setIsCallInProcess(true);
                  setIsInCall(true);
                  setCallById(null);
                  setCallToId(null);
                  seAcceptCallStatus(true);
                  setCallType("audio");
                  pause();
                  pauseAudio();
                  setAutoEndCallFunction("audio");

                  // FIX: Update unified call state to 'active' when call is accepted
                  // This starts the global duration timer in AuthContext
                  // ALSO ensure type is set for PiP display
                  updateCallState({
                    status: "active",
                    type: "audio", // FIX: Ensure type is set for PiP display
                  });

                  // Calculate userName for display (FIX: save immediately on accept)
                  // Priority: 1) selectedUser state, 2) socket event data (call_from/call_to), 3) empty
                  const userName = selectedUser?.first_name
                    ? `${selectedUser.first_name} ${
                        selectedUser.last_name || ""
                      }`.trim()
                    : (data.to == user_id ? data.call_to : data.call_from) ||
                      "";

                  // DEBUG: Log userName being saved on call acceptance

                  if (data.to == user_id) {
                    // setShowMessage(data.call_to);
                    setShowMessage(WAITING_ROOM_MESSAGE);
                    // Update callMetadata with showMessage, userName AND callType for PiP
                    setCallMetadata((prev) => ({
                      ...prev,
                      callType: "audio", // FIX: Ensure callType is set for PiP display
                      showMessage: WAITING_ROOM_MESSAGE,
                      userName: userName, // FIX: Save userName immediately on accept
                    }));
                  } else {
                    // setShowMessage(data.call_from);
                    setShowMessage(WAITING_ROOM_MESSAGE);
                    // Update callMetadata with showMessage, userName AND callType for PiP
                    setCallMetadata((prev) => ({
                      ...prev,
                      callType: "audio", // FIX: Ensure callType is set for PiP display
                      showMessage: WAITING_ROOM_MESSAGE,
                      userName: userName, // FIX: Save userName immediately on accept
                    }));

                    setCallDetails({ ...callDetails, caller_id: data.to });
                    setReceiving(true);

                    debugLog("Socket_AcceptedVoiceCall_SetReceiving", {
                      setReceiving: true,
                      reason: "incoming call accepted",
                    });
                  }
                } else {
                  debugLog("Socket_VoiceCallStart", {
                    from: data.from,
                    to: data.to,
                    isOutgoing: data.from == user_id,
                    currentStates: {
                      isInCall,
                      sendingCall,
                      receivingCall,
                      isCallMinimized,
                    },
                  });

                  // Store remote user ID when call starts
                  const remoteId = data.from == user_id ? data.to : data.from;
                  setRemoteUserId(remoteId);

                  setCallType("audio");
                  setIsCallInProcess(true);
                  setIsInCall(true);
                  if (data.from == user_id) {
                    setSendingCall(true);
                    setCallById(user_id);
                    setCallToId(data.to);
                    // setShowMessage(
                    //   data.call_to
                    //     ? `Calling to ${data.call_to}`
                    //     : "Calling ..."
                    // );
                    setShowMessage(WAITING_ROOM_MESSAGE);

                    debugLog("Socket_VoiceCallStart_SetSendingCall", {
                      setSendingCall: true,
                      setIsInCall: true,
                      reason: "outgoing voice call initiated",
                    });
                  } else {
                    setCallById(data.from);
                    setCallToId(user_id);
                    setCallDetails(data.message);

                    debugLog("Socket_VoiceCallStart_IncomingCall", {
                      setIsInCall: true,
                      reason: "incoming voice call received",
                    });
                  }
                }
              } else if (data.type == "video_call") {
                if (data.message_event_type == "accepted_video_call") {
                  debugLog("Socket_AcceptedVideoCall", {
                    from: data.from,
                    to: data.to,
                    isOutgoing: data.to == user_id,
                    currentStates: {
                      isInCall,
                      sendingCall,
                      receivingCall,
                      isCallMinimized,
                    },
                  });

                  setIsCallInProcess(true);
                  setIsInCall(true);
                  setCallById(null);
                  setCallToId(null);
                  seAcceptCallStatus(true);
                  setCallType("video");
                  pause();
                  pauseAudio();
                  setAutoEndCallFunction("video");

                  // FIX: Update unified call state to 'active' when call is accepted
                  // This starts the global duration timer in AuthContext
                  // ALSO ensure type is set for PiP display
                  updateCallState({
                    status: "active",
                    type: "video", // FIX: Ensure type is set for PiP display
                  });

                  // Calculate userName for display (FIX: save immediately on accept)
                  // Priority: 1) selectedUser state, 2) socket event data (call_from/call_to), 3) empty
                  const userName = selectedUser?.first_name
                    ? `${selectedUser.first_name} ${
                        selectedUser.last_name || ""
                      }`.trim()
                    : (data.to == user_id ? data.call_to : data.call_from) ||
                      "";

                  // DEBUG: Log userName being saved on call acceptance

                  if (data.to == user_id) {
                    // setShowMessage(data.call_to);
                    setShowMessage(WAITING_ROOM_MESSAGE);
                    // Update callMetadata with showMessage, userName AND callType for PiP
                    setCallMetadata((prev) => ({
                      ...prev,
                      callType: "video", // FIX: Ensure callType is set for PiP display
                      showMessage: WAITING_ROOM_MESSAGE,
                      userName: userName, // FIX: Save userName immediately on accept
                    }));
                  } else {
                    // setShowMessage(data.call_from);
                    setShowMessage(WAITING_ROOM_MESSAGE);
                    // Update callMetadata with showMessage, userName AND callType for PiP
                    setCallMetadata((prev) => ({
                      ...prev,
                      callType: "video", // FIX: Ensure callType is set for PiP display
                      showMessage: WAITING_ROOM_MESSAGE,
                      userName: userName, // FIX: Save userName immediately on accept
                    }));
                    setCallDetails({ ...callDetails, caller_id: data.to });
                    setReceiving(true);

                    debugLog("Socket_AcceptedVideoCall_SetReceiving", {
                      setReceiving: true,
                      reason: "incoming video call accepted",
                    });
                  }
                } else if (data.message_event_type == "end_video_call") {
                  debugLog("Socket_EndVideoCall", {
                    from: data.from,
                    to: data.to,
                    currentStates: {
                      isInCall,
                      sendingCall,
                      receivingCall,
                      isCallMinimized,
                    },
                  });

                  setIsCallInProcess(false);
                  setIsInCall(false);
                  setIsCallMinimized(false);
                  setCallById(null);
                  setCallToId(null);
                  setRemoteUserId(null); // Clear remote user ID
                  setActiveCallTabId(null); // Clear active tab
                  start();
                  pauseAudio();
                  set_socket_message(data, user_id);
                  end_video_call_fun();
                } else {
                  debugLog("Socket_VideoCallStart", {
                    from: data.from,
                    to: data.to,
                    isOutgoing: data.from == user_id,
                    currentStates: {
                      isInCall,
                      sendingCall,
                      receivingCall,
                      isCallMinimized,
                    },
                  });

                  // Store remote user ID when call starts
                  const remoteId = data.from == user_id ? data.to : data.from;
                  setRemoteUserId(remoteId);

                  setCallType("video");
                  setIsCallInProcess(true);
                  setIsInCall(true);
                  if (data.from == user_id) {
                    setSendingCall(true);
                    setCallById(user_id);
                    setCallToId(data.to);
                    // setShowMessage(
                    //   data.call_to
                    //     ? `Calling to ${data.call_to}`
                    //     : "Calling ..."
                    // );
                    setShowMessage(WAITING_ROOM_MESSAGE);

                    debugLog("Socket_VideoCallStart_SetSendingCall", {
                      setSendingCall: true,
                      setIsInCall: true,
                      reason: "outgoing video call initiated",
                    });
                  } else {
                    setCallById(data.from);
                    setCallToId(user_id);
                    setCallDetails(data.message);

                    debugLog("Socket_VideoCallStart_IncomingCall", {
                      setIsInCall: true,
                      reason: "incoming video call received",
                    });
                  }
                }
              } else {
                set_socket_message(data, user_id);
              }
            }
          }
        } catch (err) {
          console.error(err);
        }
      })();
    } catch (err) {
      console.error(err);
    }
  }, [agoraMessage]);

  useEffect(() => {
    chatRef.current = chat_id;
    if (agoraNewMessage.length) {
      const sepreatedData = agoraNewMessage[0];
      const toUserId = sepreatedData.to;
      const fromUserId = sepreatedData.user_id;

      if (
        (!userLoading && toUserId == userDetails._id) ||
        (!userLoading && fromUserId == userDetails._id)
      ) {
        const newUsers = [];
        const allUsers = usersRef.current;

        const chatUserId = toUserId == userDetails._id ? fromUserId : toUserId;
        const IsUserSender = fromUserId == userDetails._id;
        const findArr = allUsers.find((item) => {
          return item.user_id == chatUserId;
        });

        if (findArr) {
          allUsers.forEach((item) => {
            if (item.user_id == chatUserId) {
              if (IsUserSender) {
                const ItemC = item;
                ItemC.last_message = sepreatedData.last_message;
                ItemC.patient_del_status = sepreatedData.patient_del_status;
                ItemC.therapist_del_status = sepreatedData.therapist_del_status;
                ItemC.message_from = fromUserId;
                ItemC.time = sepreatedData.time;
                ItemC.unread_count = sepreatedData.unread_count;
                ItemC.type = sepreatedData.type;
                ItemC.call_status = sepreatedData.call_status;
                ItemC.call_start_time = sepreatedData.call_start_time;
                ItemC.call_end_time = sepreatedData.call_end_time;

                newUsers.push(ItemC);
              } else {
                const ItemC = item;
                ItemC.last_message = sepreatedData.last_message;
                ItemC.patient_del_status = sepreatedData.patient_del_status;
                ItemC.therapist_del_status = sepreatedData.therapist_del_status;
                ItemC.message_from = fromUserId;
                ItemC.time = sepreatedData.time;
                ItemC.unread_count = sepreatedData.unread_count;
                ItemC.type = sepreatedData.type;
                ItemC.call_status = sepreatedData.call_status;
                ItemC.call_start_time = sepreatedData.call_start_time;
                ItemC.call_end_time = sepreatedData.call_end_time;
                newUsers.push(ItemC);
              }
            } else {
              newUsers.push(item);
            }
          });

          setUsers([...newUsers]);

          usersRef.current = [...newUsers];
        } else {
          const condition_fun = (item) => {
            if (IsTherapist) {
              return sepreatedData.therapist_del_status ? false : true;
            } else {
              return sepreatedData.patient_del_status ? false : true;
            }
          };
          const user_display_cond = condition_fun(sepreatedData);
          if (!user_display_cond) return;
          setUsers([sepreatedData, ...allUsers]);
          usersRef.current = [sepreatedData, ...allUsers];
        }
      }
    }
  }, [agoraNewMessage]);

  useEffect(() => {
    fetch_communicated_clients();

    if (chat_id) {
      handle_select_user(null, chat_id);
    } else {
      // NEW: If no chat_id from URL/props, try to restore last selected user from localStorage
      try {
        const lastSelectedUserId = localStorage.getItem(
          `lastSelectedChatUser_${userDetails._id}`
        );
        if (lastSelectedUserId) {
          // Wait for users list to load before selecting
          setTimeout(() => {
            handle_select_user(null, lastSelectedUserId);
          }, 500);
        }
      } catch (storageErr) {
        console.warn("Failed to restore last selected user:", storageErr);
      }
    }

    // NEW: Store appointment data in unified state if available
    if (navigateFrom === "upcoming" && preselectedUser && preselectedUser._id) {
      setAppointmentData(preselectedUser);

      // Also update unified call state with appointment data
      updateCallState({
        appointment: {
          _id: preselectedUser._id,
          start_date_time: preselectedUser.start_date_time,
          end_date_time: preselectedUser.end_date_time,
          session_time: preselectedUser.session_time,
        },
      });
    }

    startBasicCall();
    selectedChat_user.current = chat_id;

    // Comprehensive cleanup on unmount
    return () => {
      selectedChat_user.current = "";

      // Clean up any running calls (only if not in PiP mode)
      // If in PiP, the call continues across navigation
      // IMPORTANT: Use ref to get current value (avoids stale closure)
      if (isCallInProcess && !isCallMinimizedRef.current) {
        end_call_fun();
      }

      // Clean up intervals
      // NOTE: callDuration timer is global (AuthContext), no need to clean up here
      if (endCallCounterRef.current) {
        clearInterval(endCallCounterRef.current);
        endCallCounterRef.current = null;
      }

      // Clean up Agora resources (only if not in PiP mode)
      // If in PiP, tracks and engine continue to run
      // IMPORTANT: Use ref to get current value (avoids stale closure)
      if (!isCallMinimizedRef.current) {
        try {
          // Close tracks from channelParameters
          if (channelParameters.localAudioTrack) {
            channelParameters.localAudioTrack.stop();
            channelParameters.localAudioTrack.close();
            channelParameters.localAudioTrack = null;
          }
          if (channelParameters.localVideoTrack) {
            channelParameters.localVideoTrack.stop();
            channelParameters.localVideoTrack.close();
            channelParameters.localVideoTrack = null;
          }

          // Close tracks from refs (important for video calls)
          if (localTracksRef.current.localAudioTrack) {
            localTracksRef.current.localAudioTrack.stop();
            localTracksRef.current.localAudioTrack.close();
            localTracksRef.current.localAudioTrack = null;
          }
          if (localTracksRef.current.localVideoTrack) {
            localTracksRef.current.localVideoTrack.stop();
            localTracksRef.current.localVideoTrack.close();
            localTracksRef.current.localVideoTrack = null;
          }
          if (remoteTracksRef.current.remoteAudioTrack) {
            remoteTracksRef.current.remoteAudioTrack.stop();
            remoteTracksRef.current.remoteAudioTrack = null;
          }
          if (remoteTracksRef.current.remoteVideoTrack) {
            remoteTracksRef.current.remoteVideoTrack.stop();
            remoteTracksRef.current.remoteVideoTrack = null;
          }

          const engine = getAgoraEngine();
          engine.removeAllListeners();
          engine.leave();
          agoraListenersAttached.current = false;
        } catch (err) {
          consoleService("Cleanup error on unmount:", err);
        }
      }
    };
  }, []);

  useEffect(() => {
    if (acceptThroughPopup && !call_accepted.current) {
      // Get call data from location.state (passed from App.js navigation)
      const callData = location?.state?.data;

      if (callData?.type == "voice_call") {
        acceptCallByPopupFun(callData);
      } else if (callData?.type) {
        acceptVideoCallByPopupFun(callData);
      }

      setAcceptThroughPopup(false);
      setChat_id(location?.state?.chat_id || null);
      call_accepted.current = true;
    }
  }, [acceptThroughPopup]);

  // Restore call states when component remounts with active PiP call
  // This fixes: Session timeout → Navigate away → Come back → Maximize not showing UI
  useEffect(() => {
    if (isCallMinimized && callMetadata) {
      // Restore sending/receiving states
      if (callMetadata.sendingCall) {
        setSendingCall(true);
      }
      if (callMetadata.receivingCall) {
        setReceiving(true);
      }

      // Restore call type
      if (callMetadata.callType) {
        setCallType(callMetadata.callType);
      }

      // Restore acceptCallStatus only if remote tracks exist (call is actually connected)
      if (callMetadata.remoteAudioTrack || callMetadata.remoteVideoTrack) {
        seAcceptCallStatus(true);
        setIsInCall(true);
        setIsCallInProcess(true);
      }

      // Restore tracks to refs (needed for minimize after maximize)
      // BUT: Skip if tracks are stale (after re-login, tracks reference destroyed DOM elements)
      const tracksAreStale =
        !document.getElementById("floating-remote-video") &&
        !document.getElementById("video-container");

      if (!tracksAreStale) {
        if (callMetadata.localVideoTrack) {
          localTracksRef.current.localVideoTrack = callMetadata.localVideoTrack;
          channelParameters.localVideoTrack = callMetadata.localVideoTrack;
        }
        if (callMetadata.remoteVideoTrack) {
          remoteTracksRef.current.remoteVideoTrack =
            callMetadata.remoteVideoTrack;
          channelParameters.remoteVideoTrack = callMetadata.remoteVideoTrack;
        }
        if (callMetadata.localAudioTrack) {
          localTracksRef.current.localAudioTrack = callMetadata.localAudioTrack;
          channelParameters.localAudioTrack = callMetadata.localAudioTrack;
        }
        if (callMetadata.remoteAudioTrack) {
          remoteTracksRef.current.remoteAudioTrack =
            callMetadata.remoteAudioTrack;
          channelParameters.remoteAudioTrack = callMetadata.remoteAudioTrack;
        }
      }

      // Restore chat_id and remoteUserId (needed for ending calls)
      if (callMetadata.chat_id) {
        setChat_id(callMetadata.chat_id);

        // Find and set selectedUser from users list (needed for displaying name in PiP/call screen)
        const userToSelect = users.find((u) => u._id === callMetadata.chat_id);
        if (userToSelect) {
          setSelectedUser(userToSelect);
        }

        // Load messages for the restored chat
        handle_select_user(null, callMetadata.chat_id);
      }
      if (callMetadata.remoteUserId) {
        setRemoteUserId(callMetadata.remoteUserId);
      }
    }
  }, []); // Run only once on mount

  // NEW: Handle expandingFromPip navigation flag
  // This runs when navigating to /chat with expandingFromPip=true (e.g., from payment page)
  useEffect(() => {
    if (location?.state?.expandingFromPip) {
      debugLog("Chat_ExpandFromPip_Navigation", {
        expandingFromPip: true,
        isCallMinimized,
        hasAppointmentData: !!location.state.appointment,
      });

      // Restore appointment data if available
      if (location.state.appointment) {
        setAppointmentData(location.state.appointment);
      }

      // Expand from PiP to full screen - Call handleExpand to restore all state
      // FIX: Check unifiedCallState.isMinimized (persists across navigation) OR isCallMinimized
      // Because isCallMinimized resets to false on component remount
      if (isCallMinimized || unifiedCallState.isMinimized) {
        debugLog.info(
          "Chat_ExpandFromPip_Navigation",
          "Calling handleExpand to restore call state"
        );
        handleExpand();
      }
    }
  }, [location?.state?.expandingFromPip]); // Run when expandingFromPip flag changes

  // Retry setting selectedUser when users list loads (after re-login scenario)
  useEffect(() => {
    if (isCallMinimized && callMetadata?.chat_id && users.length > 0) {
      // Check if selectedUser is missing or is wrong user
      const isWrongUser = selectedUser?._id !== callMetadata.chat_id;
      const isMissingUser = !selectedUser;

      if (isWrongUser || isMissingUser) {
        const userToSelect = users.find((u) => u._id === callMetadata.chat_id);
        if (userToSelect) {
          setSelectedUser(userToSelect);
        }
      }
    }
  }, [users, isCallMinimized, callMetadata?.chat_id, selectedUser]);

  // NEW: Session expiry monitoring
  useEffect(() => {
    // Only monitor if we have appointment data and are in a call
    if (!appointmentData?.end_date_time || !isInCall) {
      return;
    }

    debugLog("SessionExpiryMonitor_Started", {
      appointmentEndTime: appointmentData.end_date_time,
      isInCall,
      isCallMinimized,
    });

    const checkExpiry = setInterval(() => {
      const now = new Date();
      const endTime = new Date(appointmentData.end_date_time);
      const timeRemaining = endTime - now; // milliseconds

      debugLog("SessionExpiryMonitor_Check", {
        now: now.toISOString(),
        endTime: endTime.toISOString(),
        timeRemainingMinutes: Math.floor(timeRemaining / 60000),
        isExpired: now > endTime,
        warningShown: unifiedCallState.expiry.warningShown,
        expiredNotified: unifiedCallState.expiry.expiredNotified,
      });

      // 5 minute warning
      if (
        timeRemaining > 0 &&
        timeRemaining <= 5 * 60 * 1000 &&
        !unifiedCallState.expiry.warningShown
      ) {
        debugLog.warn(
          "SessionExpiryMonitor_5MinWarning",
          "Showing 5 minute warning",
          {
            timeRemainingMinutes: Math.floor(timeRemaining / 60000),
          }
        );
        toast.warning(
          "Your appointment ends in 5 minutes. Please wrap up your session.",
          {
            toastId: "session-ending-soon",
            autoClose: 10000,
            position: "top-center",
          }
        );
        updateCallState({
          expiry: { ...unifiedCallState.expiry, warningShown: true },
        });
      }

      // Session expired notification
      if (now > endTime && !unifiedCallState.expiry.expiredNotified) {
        debugLog.error(
          "SessionExpiryMonitor_SessionExpired",
          "Session time expired",
          {
            endTime: endTime.toISOString(),
            currentTime: now.toISOString(),
            isCallMinimized,
            sendingCall,
            receivingCall,
          }
        );
        toast.error(
          "Your scheduled appointment time has ended. You may continue the call, but please wrap up soon.",
          {
            toastId: "session-expired",
            autoClose: 15000,
            position: "top-center",
          }
        );
        updateCallState({
          expiry: {
            ...unifiedCallState.expiry,
            expiredNotified: true,
            isExpired: true,
          },
        });
      }
    }, 30000); // Check every 30 seconds

    // Cleanup
    return () => {
      debugLog("SessionExpiryMonitor_Cleanup", { reason: "useEffect cleanup" });
      clearInterval(checkExpiry);
    };
  }, [appointmentData, isInCall, unifiedCallState.expiry]);

  // Reset expiry flags when call ends
  useEffect(() => {
    if (!isInCall && unifiedCallState.expiry.warningShown) {
      updateCallState({
        expiry: {
          warningShown: false,
          expiredNotified: false,
          isExpired: false,
        },
      });
    }
  }, [isInCall]);

  useEffect(() => {
    if (scroll.current == null) return;
    if (messages.length > 20) {
      if (bySubmitMessage) {
        scroll.current.scrollTop = scroll.current.scrollHeight;
      } else {
        scroll.current.scrollTop = scrollPosition;
      }
    } else {
      scroll.current.scrollTop = scroll.current.scrollHeight;
    }
  }, [messages]);

  useEffect(() => {
    if (scroll.current == null) return;
    if (sendingCall) return;
    if (messages.length > 20) {
      if (bySubmitMessage) {
        scroll.current.scrollTop = scroll.current.scrollHeight;
      } else {
        scroll.current.scrollTop = scrollPosition;
      }
    } else {
      scroll.current.scrollTop = scroll.current.scrollHeight;
    }
  }, [sendingCall]);

  // NOTE: Call duration timer moved to AuthContext (global, ref-based)
  // Duration is tracked in ref, accessed via getCallDuration() to prevent re-renders
  // This ensures duration continues counting during navigation and PiP
  // No local timer or sync needed here anymore - duration is always available globally

  // Continuously sync tracks to callMetadata when minimized (fixes tracks publishing after minimize)
  useEffect(() => {
    if (isCallMinimized && (sendingCall || receivingCall)) {
      const localVideo =
        localTracksRef.current.localVideoTrack ||
        channelParameters.localVideoTrack;
      const remoteVideo =
        remoteTracksRef.current.remoteVideoTrack ||
        channelParameters.remoteVideoTrack;
      const localAudio =
        localTracksRef.current.localAudioTrack ||
        channelParameters.localAudioTrack;
      const remoteAudio =
        remoteTracksRef.current.remoteAudioTrack ||
        channelParameters.remoteAudioTrack;

      // Update user name if selectedUser is available
      const currentUserName = selectedUser?.first_name
        ? `${selectedUser.first_name} ${selectedUser.last_name || ""}`.trim()
        : "";

      setCallMetadata((prev) => ({
        ...prev,
        localVideoTrack: localVideo,
        remoteVideoTrack: remoteVideo,
        localAudioTrack: localAudio,
        remoteAudioTrack: remoteAudio,
        showMessage: remoteAudio || remoteVideo ? "" : prev.showMessage, // Clear message when tracks arrive
        userName: currentUserName || prev.userName, // Update userName if available, otherwise keep previous
      }));
    }
  }, [
    isCallMinimized,
    sendingCall,
    receivingCall,
    selectedUser, // Add selectedUser to trigger update when it changes
    localTracksRef.current.localVideoTrack,
    localTracksRef.current.remoteVideoTrack,
    localTracksRef.current.localAudioTrack,
    localTracksRef.current.remoteAudioTrack,
  ]);

  // Re-play video tracks when expanding from PiP
  useEffect(() => {
    if (!isCallMinimized && isVideoCall && (sendingCall || receivingCall)) {
      const timer = setTimeout(() => {
        const localVideo = localTracksRef.current.localVideoTrack;
        const remoteVideo = remoteTracksRef.current.remoteVideoTrack;

        if (localVideo) {
          const localElement =
            document.getElementById("local-video-container-1") ||
            document.getElementById("local-video-container-2");
          if (localElement) {
            consoleService("Re-playing local video to:", localElement.id);
            localVideo.play(localElement.id);
          }
        }

        if (remoteVideo) {
          const remoteContainer = document.getElementById("video-container");
          if (remoteContainer) {
            consoleService("Re-playing remote video to: video-container");
            remoteVideo.play("video-container");
          }
        }
      }, 300);

      return () => clearTimeout(timer);
    }
  }, [isCallMinimized, isVideoCall, sendingCall, receivingCall]);

  // Populate endCallFunctionRef so App.js can call end functions from PiP
  useEffect(() => {
    endCallFunctionRef.current = {
      endAudioCall: () => {
        // Use role from unified state (more reliable after remount)
        const isCaller = unifiedCallState.role === "caller" || sendingCall;

        if (isCaller) {
          endCallByCallerFun();
        } else {
          endCallByReceiverFun();
        }
      },
      endVideoCall: () => {
        // Use role from unified state (more reliable after remount)
        const isCaller = unifiedCallState.role === "caller" || sendingCall;

        if (isCaller) {
          endVidioCallByCallerFun();
        } else {
          endVideoCallByReceiverFun();
        }
      },
      toggleMute: set_video_call_mute_unmute,
      toggleVideo: set_hide_unhide_video_fun,
      expandFromPip: handleExpand,
    };

    // Also populate minimizeFunctionRef so App.js can call handleMinimize
    minimizeFunctionRef.current = handleMinimize;
  }, [hide_video, mute_audio, sendingCall, unifiedCallState.role]); // Update when these change so functions have latest state

  ///////////////////////////////////////////////FUNCTIONS ///////////////////////////////////////////////

  function set_socket_message(data, user_id) {
    if (data.from == user_id) {
      setSendMessageLoading(false);
    }

    setMessages((pre) => [...pre, data]);

    // Only clear call type if it's a call-related message, not a text/image message
    if (data.type === "voice_call" || data.type === "video_call") {
      setCallType("");
    }

    // Show notification logic
    const isTextOrImageMessage =
      data.type === "message" || data.type === "image";

    if (isTextOrImageMessage && (sendingCall || receivingCall)) {
      // Don't show notification for own messages
      if (data.from === user_id) {
        return;
      }

      // Full screen mode: Always show notification
      // PiP mode: Only show if message is from someone other than current chat
      const shouldShowNotification =
        !isCallMinimized || (isCallMinimized && data.from !== chat_id);

      if (shouldShowNotification) {
        // Find sender name from users list
        const sender = users.find((u) => u._id === data.from);

        const senderName = sender
          ? `${sender.first_name || ""} ${sender.last_name || ""}`.trim()
          : selectedUser?.first_name
          ? `${selectedUser.first_name} ${selectedUser.last_name || ""}`.trim()
          : "Unknown";

        const messagePreview =
          data.type === "image"
            ? "Sent an image"
            : (data.message || "").substring(0, 40) +
              ((data.message || "").length > 40 ? "..." : "");

        toast(`New message from ${senderName}: ${messagePreview}`, {
          autoClose: 4000,
          position: "top-right",
          hideProgressBar: true,
          type: "success",
          icon: false,
          onClick: () => {
            // If call is in full screen, minimize to PiP
            if (!isCallMinimized) {
              handleMinimize();
            }

            // If message is from someone other than current chat, switch to that chat
            if (data.from !== chat_id) {
              const messageSender = users.find((u) => u._id === data.from);
              if (messageSender) {
                setSelectedUser(messageSender);
                setChat_id(data.from);
                setWindowClass("backHideShow");
              }
            }
          },
        });
      }
    }

    if (scroll.current) {
      setScrollPosition(scroll.current.scrollHeight);
    }

    if (data.from == chat_id && data.to == user_id) {
      socket.emit("check_id", {
        sender: chat_id,
        receiver: user_id,
      });
      setBySubmitMessage(false);
    } else {
      setBySubmitMessage(true);
    }
  }

  // ============================================================================
  // MULTI-DEVICE CALL HANDLING - Helper function
  // Added: Handle when call is answered on another device
  // ============================================================================

  /**
   * Handle call answered on another device
   * Dismisses local UI and keeps device in normal state
   * @param {Object} data - Socket event data
   */
  const handle_call_answered_elsewhere = (data) => {
    try {
      // ============================================================================
      // 🆕 MULTI-DEVICE FIX: Stop all audio (ringtone)
      // ============================================================================

      pauseAudio(); // Stop ringtone via AuthContext

      // Also stop any HTML audio elements that might be playing
      if (receive_call_audio) {
        receive_call_audio.pause();
        receive_call_audio.currentTime = 0;
      }

      // Clear any active ringtone reference
      if (window.activeRingtone) {
        window.activeRingtone.pause();
        window.activeRingtone.currentTime = 0;
        window.activeRingtone = null;
      }

      toast.dismiss(); // Dismiss all toasts

      // Reset call states (don't show call UI)
      setIsCallInProcess(false);
      setCallLoading(false);
      setVideoCallLoading(false);
      setReceiving(false);
      setSendingCall(false);
      setIsInCall(false); // Also reset isInCall
      setIsCallMinimized(false); // ⚠️ CRITICAL: Clear minimized state to hide PiP
      setCallById(null);
      setCallToId(null);
      setRemoteUserId(null); // Clear remote user ID
      setActiveCallTabId(null); // Clear active tab

      // ============================================================================
      // 🔧 FIX: Clear global unified call state to prevent PiP showing after navigation
      // This ensures that when user navigates (e.g., from payment page), the PiP doesn't reappear
      // ============================================================================

      updateCallState({
        status: "idle",
        isMinimized: false,
        type: null,
        chat_id: null,
        user: null,
      });

      consoleService(
        "✅ Local UI dismissed - call is active on another device"
      );
    } catch (err) {
      console.error("❌ [DEBUG] Error in handle_call_answered_elsewhere:", err);
      consoleService("❌ Error in handle_call_answered_elsewhere =", err);
    }
  };

  const sideBarHide = () => {
    setfilterHideShow(!filterHideShow);
  };

  const handle_back_press = async () => {
    // Check if user is in an active call
    if (sendingCall || receivingCall || isCallInProcess) {
      const confirmed = window.confirm(
        "You are currently in a call. Ending the call will disconnect you. Do you want to continue?"
      );

      if (!confirmed) {
        return; // User cancelled, stay on page
      }

      // User confirmed - end the call first
      if (callType === "audio") {
        if (sendingCall) {
          await endCallByCallerFun();
        } else {
          await endCallByReceiverFun();
        }
      } else if (callType === "video") {
        if (sendingCall) {
          await endVidioCallByCallerFun();
        } else {
          await endVideoCallByReceiverFun();
        }
      }
    }

    setMessages([]);
    setWindowClass("hideShow");
  };

  async function end_call_fun() {
    try {
      debugLog.entry("end_call_fun", {
        isInCall,
        sendingCall,
        receivingCall,
        isCallMinimized,
        callType,
      });

      setSendingCall(false);
      setReceiving(false);
      seAcceptCallStatus(false);
      setIsCallInProcess(false);
      setIsInCall(false);

      debugLog("end_call_fun_StateReset", {
        setSendingCall: false,
        setReceiving: false,
        setIsInCall: false,
        setIsCallInProcess: false,
      });
      // Don't expand if ending from PiP - let App.js handle it
      // Only reset if not minimized (ending from main screen)
      if (!isCallMinimizedRef.current) {
        setIsCallMinimized(false);
      }
      setCallType("");
      setCallLoading(false);
      setRunningCallId("");
      setEndCallMessage("");
      if (endCallCounterRef.current != null) {
        clearInterval(endCallCounterRef.current);
        endCallCounterRef.current = null;
      }
      // Clear session timeout when call ends
      if (sessionTimeoutRef.current) {
        clearTimeout(sessionTimeoutRef.current);
        sessionTimeoutRef.current = null;
      }
      // Clear multi-tab coordination state
      setRemoteUserId(null);
      setActiveCallTabId(null);
      setIsEndingCall(false);
      call_accepted.current = false;

      // NEW: Reset unified call state
      resetCallState();

      // Get all tracks from Agora engine before leaving
      try {
        const engine = getAgoraEngine();
        const localTracks = engine.localTracks || [];

        localTracks.forEach((track) => {
          try {
            track.stop();
            track.close();
          } catch (err) {
            console.error("Error stopping track:", err);
          }
        });
      } catch (err) {
        console.error("Error getting Agora tracks:", err);
      }

      // Proper track cleanup - stop before close
      if (
        channelParameters.localVideoTrack ||
        localTracksRef.current.localVideoTrack
      ) {
        const track =
          channelParameters.localVideoTrack ||
          localTracksRef.current.localVideoTrack;
        track.stop();
        track.close();
        channelParameters.localVideoTrack = null;
        localTracksRef.current.localVideoTrack = null;
        setShowMessage("");
      }
      if (
        channelParameters.localAudioTrack ||
        localTracksRef.current.localAudioTrack
      ) {
        const track =
          channelParameters.localAudioTrack ||
          localTracksRef.current.localAudioTrack;
        track.stop();
        track.close();
        channelParameters.localAudioTrack = null;
        localTracksRef.current.localAudioTrack = null;
        setShowMessage("");
      }
      // Clean remote tracks
      channelParameters.remoteAudioTrack = null;
      channelParameters.remoteVideoTrack = null;
      remoteTracksRef.current.remoteAudioTrack = null;
      remoteTracksRef.current.remoteVideoTrack = null;

      await getAgoraEngine().leave();

      // Extra cleanup: Stop any orphaned media streams in DOM elements
      setTimeout(() => {
        document.querySelectorAll("video, audio").forEach((element) => {
          if (element.srcObject) {
            const stream = element.srcObject;
            stream.getTracks().forEach((track) => track.stop());
            element.srcObject = null;
          }
        });
      }, 100);

      // Reset minimized state after cleanup completes (for PiP ended calls)
      setTimeout(() => {
        setIsCallMinimized(false);
      }, 200);
    } catch (err) {
      consoleService("error in end_call_fun =", err);
    }
  }

  async function end_video_call_fun() {
    try {
      debugLog.entry("end_video_call_fun", {
        isInCall,
        sendingCall,
        receivingCall,
        isCallMinimized,
        callType,
      });

      setCallType("");
      setSendingCall(false);
      setReceiving(false);
      seAcceptCallStatus(false);
      setIsCallInProcess(false);
      setIsInCall(false);

      debugLog("end_video_call_fun_StateReset", {
        setSendingCall: false,
        setReceiving: false,
        setIsInCall: false,
        setIsCallInProcess: false,
        setCallType: "",
      });
      // Don't expand if ending from PiP - let App.js handle it
      // Only reset if not minimized (ending from main screen)
      if (!isCallMinimizedRef.current) {
        setIsCallMinimized(false);
      }
      setVideoCallLoading(false);
      setRunningCallId("");
      setEndCallMessage("");
      if (endCallCounterRef.current != null) {
        clearInterval(endCallCounterRef.current);
        endCallCounterRef.current = null;
      }
      // Clear session timeout when call ends
      if (sessionTimeoutRef.current) {
        clearTimeout(sessionTimeoutRef.current);
        sessionTimeoutRef.current = null;
      }
      // Clear multi-tab coordination state
      setRemoteUserId(null);
      setActiveCallTabId(null);
      setIsEndingCall(false);

      call_accepted.current = false;

      // NEW: Reset unified call state
      resetCallState();

      // Get all tracks from Agora engine before leaving
      try {
        const engine = getAgoraEngine();
        const localTracks = engine.localTracks || [];

        localTracks.forEach((track, index) => {
          try {
            track.stop();
            track.close();
          } catch (err) {}
        });
      } catch (err) {}

      // Proper track cleanup - stop before close
      if (
        channelParameters.localVideoTrack ||
        localTracksRef.current.localVideoTrack
      ) {
        const track =
          channelParameters.localVideoTrack ||
          localTracksRef.current.localVideoTrack;
        track.stop();
        track.close();
        channelParameters.localVideoTrack = null;
        localTracksRef.current.localVideoTrack = null;
        setShowMessage("");
      }
      if (
        channelParameters.localAudioTrack ||
        localTracksRef.current.localAudioTrack
      ) {
        const track =
          channelParameters.localAudioTrack ||
          localTracksRef.current.localAudioTrack;
        track.stop();
        track.close();
        channelParameters.localAudioTrack = null;
        localTracksRef.current.localAudioTrack = null;
        setShowMessage("");
      }
      // Clean remote tracks
      channelParameters.remoteAudioTrack = null;
      channelParameters.remoteVideoTrack = null;
      remoteTracksRef.current.remoteAudioTrack = null;
      remoteTracksRef.current.remoteVideoTrack = null;

      // Also clean tracks from callMetadata to ensure browser releases microphone/camera
      if (callMetadata.localAudioTrack) {
        try {
          callMetadata.localAudioTrack.stop();
          callMetadata.localAudioTrack.close();
        } catch (err) {}
      }
      if (callMetadata.localVideoTrack) {
        try {
          callMetadata.localVideoTrack.stop();
          callMetadata.localVideoTrack.close();
        } catch (err) {}
      }

      // Clear callMetadata tracks
      setCallMetadata({
        callType: "",
        sendingCall: false,
        receivingCall: false,
        mute_audio: false,
        hide_video: false,
        showMessage: "",
        callDuration: 0,
        localVideoTrack: null,
        remoteVideoTrack: null,
        localAudioTrack: null,
        remoteAudioTrack: null,
        userName: "",
      });

      await getAgoraEngine().leave();

      // Reset minimized state after cleanup completes (for PiP ended calls)
      setTimeout(() => {
        setIsCallMinimized(false);
      }, 200);
    } catch (err) {
      consoleService("error in end_video_call_fun =", err);
    }
  }

  async function setAutoEndCallFunction(type) {
    // Validate that chat times exist before proceeding
    if (!chat_start_time || !chat_end_time) {
      return;
    }

    const startTime = new Date(chat_start_time);
    const endTime = new Date(chat_end_time);
    const currentTime = new Date();

    // Validate that dates are valid
    if (isNaN(startTime.getTime()) || isNaN(endTime.getTime())) {
      return;
    }

    const remainingTimeMillis = endTime - currentTime;

    // Clear any existing session timeout to prevent duplicates
    if (sessionTimeoutRef.current) {
      clearTimeout(sessionTimeoutRef.current);
      sessionTimeoutRef.current = null;
    }

    if (currentTime >= startTime && currentTime <= endTime) {
      if (remainingTimeMillis > 0) {
        const remainingTime = Math.floor(remainingTimeMillis / 1000);
        sessionTimeoutRef.current = setTimeout(async () => {
          try {
            // Show session end notification based on user role
            const sessionEndMessage =
              authUserRole === "Therapist"
                ? "Your session time has ended. You may continue or ask your client to rebook for another appointment."
                : "Your session time has ended. You can rebook your therapist for another appointment.";

            toast.info(sessionEndMessage, {
              toastId: "session-end-notification", // Unique ID to prevent duplicates
              position: "top-center",
              autoClose: 8000, // Auto-close after 5 seconds
              closeOnClick: true,
              draggable: false,
              style: {
                background: "#000000",
                color: "#ffffff",
                border: "1px solid #ffffff",
              },
            });

            // COMMENTED OUT: Auto-disconnect functionality
            // Call will continue, users can manually end when ready
            /*
            setSendingCall(false);
            setReceiving(false);
            seAcceptCallStatus(false);

            setCallType("");
            setCallLoading(false);
            setVideoCallLoading(false);
            call_accepted.current = false;
            window.location.reload(false);
            if (channelParameters.localVideoTrack) {
              channelParameters.localVideoTrack.close();

              setShowMessage("");
            }
            if (channelParameters.localAudioTrack) {
              channelParameters.localAudioTrack.close();

              setShowMessage("");
            }
            if (type == "audio") {
              const running_call_id = get_running_call_id();
              end_call_fun();
              if (!socket) return;
              socket.emit("message", {
                message_event_type: "end_voice_call",
                type: "voice_call",
                end_by: userDetails._id,
                call_status: "end",
                message_id: running_call_id,
              });
            } else {
              const running_call_id = get_running_call_id();
              end_video_call_fun();
              if (!socket) return;

              socket.emit("message", {
                end_by: userDetails._id,
                message_event_type: "end_video_call",
                type: "video_call",
                call_status: "end",
                message_id: running_call_id,
              });
            }

            await getAgoraEngine().leave();
            */
          } catch (err) {
            consoleService("error in auto cut call fun = ", err);
          }
        }, remainingTime * 1000);
      }
    }
  }

  const requestAudioPermissions = async () => {
    let audioDeviceExists = true; // Assume exists until proven otherwise

    // ============================================================================
    // STEP 1: Try to get microphone permission
    // ============================================================================
    try {
      // Request microphone permissions
      const stream = await navigator.mediaDevices.getUserMedia({
        video: false,
        audio: true,
      });

      // Stop the tracks immediately to release the devices
      stream.getTracks().forEach((track) => track.stop());

      return true; // Permission granted
    } catch (error) {
      console.error("❌ Microphone access failed:", error.name, error.message);

      // ============================================================================
      // STEP 2: Determine if device doesn't exist OR permission was denied
      // ============================================================================
      if (
        error.name === "NotFoundError" ||
        error.message.includes("Requested device not found")
      ) {
        // Device doesn't exist - show tooltip and BLOCK
        audioDeviceExists = false;
        console.log("⚠️ No microphone device found");

        setShowMessage(
          "Microphone unavailable. Please connect a microphone to make calls."
        );
        setTimeout(() => setShowMessage(""), 8000);
        return false; // BLOCK the call
      }

      // ============================================================================
      // STEP 3: Permission denied - show error toast with retry button
      // ============================================================================
      console.log("⚠️ Microphone permission denied");

      const MicPermissionToast = () => (
        <div>
          <p style={{ marginBottom: "10px" }}>
            Microphone access denied. Please allow microphone access to make
            calls.
          </p>
          <button
            onClick={async () => {
              toast.dismiss();
              // Retry permission request
              try {
                const stream = await navigator.mediaDevices.getUserMedia({
                  video: false,
                  audio: true,
                });
                stream.getTracks().forEach((track) => track.stop());
                toast.success(
                  "Microphone permission granted! Please try your call again.",
                  {
                    position: "top-center",
                    autoClose: 3000,
                  }
                );
              } catch (retryError) {
                toast.error(
                  "Still unable to access microphone. Please check your browser settings.",
                  {
                    position: "top-center",
                    autoClose: 5000,
                  }
                );
              }
            }}
            style={{
              backgroundColor: "#1d7e7c",
              color: "white",
              border: "none",
              padding: "8px 16px",
              borderRadius: "4px",
              cursor: "pointer",
              fontWeight: "500",
            }}
          >
            Allow Microphone
          </button>
        </div>
      );

      toast.error(<MicPermissionToast />, {
        position: "top-center",
        autoClose: false,
        closeOnClick: false,
        hideProgressBar: true,
      });
      return false; // Permission denied - BLOCK the call
    }
  };

  const request_audio_video_permissions = async () => {
    try {
      // Request camera & microphone permissions
      const stream = await navigator.mediaDevices.getUserMedia({
        video: true,
        audio: true,
      });

      // Stop the tracks immediately to release the devices
      stream.getTracks().forEach((track) => track.stop());

      return true; // Permission granted
    } catch (error) {
      console.error("Permission denied:", error);
      toast.error("Camera and microphone not found or permission denied.", {
        position: "top-center",
        autoClose: 3000,
      });
      return false; // Permission denied
    }
  };

  // NEW: Re-apply call state after reconnection
  const reapplyCallState = async () => {
    try {
      // Re-apply audio mute state
      if (localTracksRef.current.localAudioTrack) {
        if (mute_audio) {
          await localTracksRef.current.localAudioTrack.setEnabled(false);
        } else {
          await localTracksRef.current.localAudioTrack.setEnabled(true);
        }
      }

      // Re-apply video hide state
      if (localTracksRef.current.localVideoTrack) {
        if (hide_video) {
          await localTracksRef.current.localVideoTrack.setEnabled(false);
        } else {
          await localTracksRef.current.localVideoTrack.setEnabled(true);
        }
      }

      // Update unified call state
      updateCallState({
        isMuted: mute_audio,
        isVideoHidden: hide_video,
        showMessage: "",
      });

      // Update old call metadata for backward compatibility
      setCallMetadata((prev) => ({
        ...prev,
        mute_audio,
        hide_video,
        showMessage: "",
      }));
    } catch (error) {
      console.error("❌ Error re-applying call state:", error);
    }
  };

  async function startBasicCall() {
    try {
      const engine = getAgoraEngine();

      // Only attach listeners once to prevent duplicates
      if (!agoraListenersAttached.current) {
        engine.on("user-published", async (user, mediaType) => {
          try {
            // Subscribe to the remote user when the SDK triggers the "user-published" event.
            await engine.subscribe(user, mediaType);

            // Subscribe and play the remote audio track.
            if (mediaType == "audio") {
              channelParameters.remoteUid = user.uid;
              // Get the RemoteAudioTrack object from the AgoraRTCRemoteUser object.
              channelParameters.remoteAudioTrack = user.audioTrack;
              remoteTracksRef.current.remoteAudioTrack = user.audioTrack;
              // Play the remote audio track.
              channelParameters.remoteAudioTrack?.play();

              // Use ref to get current value (avoids stale closure)
              const currentIsMinimized = isCallMinimizedRef.current;

              // Clear waiting message
              setShowMessage("");

              // Update callMetadata for PiP if minimized
              if (currentIsMinimized) {
                setCallMetadata((prev) => ({
                  ...prev,
                  remoteAudioTrack: user.audioTrack,
                  showMessage: "",
                }));
              }
            } else if (mediaType === "video") {
              // Handle video tracks
              const remoteVideoTrack = user.videoTrack;
              channelParameters.remoteVideoTrack = remoteVideoTrack;
              remoteTracksRef.current.remoteVideoTrack = remoteVideoTrack;

              // Use ref to get current value (avoids stale closure)
              const currentIsMinimized = isCallMinimizedRef.current;

              // Clear waiting message
              setShowMessage("");

              if (remoteVideoTrack) {
                if (currentIsMinimized) {
                  // If in PiP mode, update callMetadata and play to PiP element
                  setCallMetadata((prev) => ({
                    ...prev,
                    remoteVideoTrack: remoteVideoTrack,
                    showMessage: "",
                  }));

                  // FIX: Check if element exists before attempting to play
                  setTimeout(() => {
                    const floatingElement = document.getElementById(
                      "floating-remote-video"
                    );
                    if (
                      floatingElement &&
                      remoteVideoTrack.isPlaying === false
                    ) {
                      const playPromise = remoteVideoTrack.play(
                        "floating-remote-video"
                      );
                      if (
                        playPromise &&
                        typeof playPromise.catch === "function"
                      ) {
                        playPromise.catch((err) => {
                          console.warn(
                            "⚠️ Remote video play interrupted (expected during hide/show):",
                            err.message
                          );
                        });
                      }
                    }
                  }, 150); // Increased delay slightly for stability
                } else {
                  // If in main screen, play to main video container
                  const videoContainer =
                    document.getElementById("video-container");
                  if (videoContainer && remoteVideoTrack.isPlaying === false) {
                    const playPromise =
                      remoteVideoTrack.play("video-container");
                    if (
                      playPromise &&
                      typeof playPromise.catch === "function"
                    ) {
                      playPromise.catch((err) => {
                        console.warn(
                          "⚠️ Remote video play interrupted (expected during hide/show):",
                          err.message
                        );
                      });
                    }
                  }
                }
              }
            }
          } catch (err) {
            consoleService("Error handling user-published:", err);
          }
        });

        // Listen for the "user-unpublished" event.
        engine.on("user-unpublished", (user, mediaType) => {
          if (mediaType === "audio" || !mediaType) {
            // Clean up audio track
            if (channelParameters.remoteAudioTrack) {
              channelParameters.remoteAudioTrack = null;
            }
            remoteTracksRef.current.remoteAudioTrack = null;
          }

          if (mediaType === "video" || !mediaType) {
            // Clean up video track
            if (channelParameters.remoteVideoTrack) {
              channelParameters.remoteVideoTrack = null;
            }
            remoteTracksRef.current.remoteVideoTrack = null;

            // Update unified state to reflect no remote video
            updateCallState({
              tracks: {
                ...unifiedCallState.tracks,
                remoteVideo: null,
              },
            });

            // Update old call metadata
            setCallMetadata((prev) => ({
              ...prev,
              remoteVideoTrack: null,
            }));

            // Don't show message - let UI handle it naturally
          }
        });

        // Add connection state monitoring with smart reconnection
        let disconnectedSince = null;
        let reconnectionTimeout = null;
        let hasBeenDisconnected = false; // Only show "restored" if we were actually DISCONNECTED first

        engine.on("connection-state-change", (curState, prevState) => {
          if (curState === "DISCONNECTED") {
            disconnectedSince = Date.now();
            hasBeenDisconnected = true; // Mark that we've experienced a disconnection

            // Show reconnecting UI immediately
            setShowMessage("Connection lost. Reconnecting...");

            // Set 30-second timeout to end call if no reconnection
            reconnectionTimeout = setTimeout(() => {
              const disconnectedFor = Date.now() - disconnectedSince;
              if (
                disconnectedFor >= 30000 &&
                getAgoraEngine().connectionState === "DISCONNECTED"
              ) {
                setShowMessage("Call ended due to connection failure");
                setTimeout(() => setShowMessage(""), 3000);
                end_call_fun();
              }
            }, 30000);
          } else if (curState === "RECONNECTING") {
            hasBeenDisconnected = true; // Mark that we've experienced connection issues
            setShowMessage("Reconnecting...");
          } else if (curState === "CONNECTED") {
            // Clear timeout - we're connected
            if (reconnectionTimeout) {
              clearTimeout(reconnectionTimeout);
              reconnectionTimeout = null;
            }

            // Only show "Connection restored" if we were DISCONNECTED/RECONNECTING before
            // This prevents showing it during initial connection
            if (
              hasBeenDisconnected &&
              (prevState === "DISCONNECTED" || prevState === "RECONNECTING")
            ) {
              // Re-apply mute/hide state after reconnection
              reapplyCallState();

              // Show small tooltip-like notification at top center
              const notification = document.createElement("div");
              notification.textContent = "Connection restored";
              notification.style.cssText = `
                position: fixed;
                top: 20px;
                left: 50%;
                transform: translateX(-50%);
                background: rgba(46, 125, 50, 0.95);
                color: white;
                padding: 8px 16px;
                border-radius: 4px;
                font-size: 13px;
                font-weight: 500;
                z-index: 10000;
                box-shadow: 0 2px 8px rgba(0,0,0,0.2);
                animation: fadeIn 0.3s ease-in;
              `;
              document.body.appendChild(notification);
              setTimeout(() => {
                notification.style.animation = "fadeOut 0.3s ease-out";
                setTimeout(() => notification.remove(), 300);
              }, 2000);
            }

            disconnectedSince = null;
          }
        });

        // Add network quality monitoring
        engine.on("network-quality", (quality) => {
          const { uplinkNetworkQuality, downlinkNetworkQuality } = quality;
          setNetworkQuality({
            uplink: uplinkNetworkQuality,
            downlink: downlinkNetworkQuality,
          });

          // Check if network is poor (quality >= 3 means poor or worse)
          const isPoor =
            uplinkNetworkQuality >= 3 || downlinkNetworkQuality >= 3;
          setIsNetworkPoor(isPoor);

          // Show warning for bad network (quality >= 4)
          const isBad =
            uplinkNetworkQuality >= 4 || downlinkNetworkQuality >= 4;
          setShowNetworkWarning(isBad);

          if (isBad) {
            consoleService("Poor network detected:", {
              uplink: uplinkNetworkQuality,
              downlink: downlinkNetworkQuality,
            });
          }
        });

        // Enable network quality reporting
        engine.enableAudioVolumeIndicator();

        agoraListenersAttached.current = true;
      }
    } catch (err) {
      consoleService("error in start basic call =", err);
    }
  }

  // Check if user is busy before initiating call
  const checkUserBusyStatus = (userId) => {
    return new Promise((resolve, reject) => {
      if (!socket) {
        reject(new Error("Socket not connected"));
        return;
      }

      // Set timeout for response (5 seconds)
      const timeout = setTimeout(() => {
        socket.off("user_busy_status_response", responseHandler);
        console.error("⏱️ Busy status check timeout");
        reject(new Error("Busy status check timeout"));
      }, 5000);

      // Response handler
      const responseHandler = (data) => {
        if (data.user_id === userId) {
          clearTimeout(timeout);
          socket.off("user_busy_status_response", responseHandler);

          resolve(data);
        }
      };

      // Listen for response
      socket.on("user_busy_status_response", responseHandler);

      // Emit check request
      socket.emit("check_user_busy_status", {
        user_id: userId,
        caller_id: userDetails._id,
      });
    });
  };

  async function join_chat_fun() {
    try {
      // STEP 1: Check if CALLER (me) is busy on another device
      // This prevents making calls when already in a call on another device

      setCallLoading(true);
      setVideoCallLoading(false);

      let myBusyStatus;
      try {
        myBusyStatus = await checkUserBusyStatus(userDetails._id);
      } catch (busyCheckError) {
        console.error("Failed to check my busy status:", busyCheckError);
        toast.error("Failed to check call status. Please try again.", {
          autoClose: 3000,
        });
        setCallLoading(false);
        return;
      }

      // If I am busy (calling/in call on another device), block this call
      if (myBusyStatus.is_busy) {
        toast.error(BUSY_SESSION_MESSAGE, {
          autoClose: 4000,
          toastId: `self-busy-${userDetails._id}`,
        });
        setCallLoading(false);
        return; // STOP HERE - Don't proceed with call
      }

      // STEP 2: Check if RECEIVER is busy BEFORE initiating call
      let busyStatus;
      try {
        busyStatus = await checkUserBusyStatus(chat_id);
      } catch (busyCheckError) {
        console.error("Failed to check busy status:", busyCheckError);
        toast.error("Failed to check user availability. Please try again.", {
          autoClose: 3000,
        });
        setCallLoading(false);
        return;
      }

      // If receiver is busy, show message and stop
      if (busyStatus.is_busy) {
        const selectedUser = users.find(
          (item) => item._id == chat_id || item.user_id == chat_id
        );
        const userName = selectedUser?.first_name
          ? `${selectedUser.first_name} ${selectedUser.last_name || ""}`.trim()
          : busyStatus.user_name || "User";

        const callTypeText =
          busyStatus.call_type === "video_call" ? "video" : "voice";

        toast.error(
          `${userName} is currently on another call. Please try again later.`,
          {
            autoClose: 4000,
            toastId: `busy-${chat_id}`,
          }
        );

        setCallLoading(false);
        return; // STOP HERE - Don't proceed with call
      }

      // STEP 3: Check multi-tab (prevent multiple calls from different tabs)
      if (activeCallTabId && activeCallTabId !== tabId) {
        toast.error("A call is already active in another tab", {
          toastId: "call-in-another-tab",
          autoClose: 3000,
        });
        setCallLoading(false);
        return;
      }

      // STEP 4: Proceed with normal call flow

      const hasPermissions = await requestAudioPermissions();

      if (!hasPermissions) {
        setCallLoading(false);
        return;
      }

      setEndCallMessage("");
      const selectedUser = users.find(
        (item) => item._id == chat_id || item.user_id == chat_id
      );
      setSelectedUser(selectedUser); // Update global selectedUser for UI display
      const token = await get_agora_token(options.channel);
      options.token = token;
      options.caller_id = userDetails._id;
      options.patientDetails = userDetails;
      socket &&
        socket.emit(
          "message",
          {
            from: userDetails._id,
            to: chat_id,
            type: "voice_call",
            message: options,
            call_from: `${userDetails.first_name} ${userDetails.last_name}`,
            call_to: selectedUser.first_name
              ? `${selectedUser.first_name} ${selectedUser.last_name}`
              : "",
          },
          async (response) => {
            try {
              setRunningCallId(response.data.message_id);
              setCallType("audio");

              // Mark this tab as the active caller
              setActiveCallTabId(tabId);
              setRemoteUserId(chat_id);

              // Broadcast to other tabs that this tab is making the call
              if (audioChannel) {
                audioChannel.postMessage({
                  type: "call_accepted_by_tab",
                  tabId: tabId,
                  payload: {
                    remoteUserId: chat_id,
                    callType: "audio",
                  },
                });
              }

              setSendingCall(true);
              setIsCallInProcess(true);
              setIsInCall(true);
              setMuteAudio(false);
              setHideVideo(false);

              // NEW: Update unified call state
              updateCallState({
                status: "ringing_out",
                type: "audio",
                role: "caller",
                chat_id: chat_id,
                remoteUserId: chat_id,
                message_id: response.data.message_id,
                user: {
                  _id: selectedUser?._id || chat_id,
                  first_name: selectedUser?.first_name || "",
                  last_name: selectedUser?.last_name || "",
                  profile_image: selectedUser?.profile_image || "",
                },
                showMessage: WAITING_ROOM_MESSAGE,
                isMuted: false,
                isVideoHidden: false,
                activeTabId: tabId,
              });
              // setShowMessage(
              //   selectedUser?.first_name != undefined
              //     ? `Calling to ${selectedUser.first_name} ${selectedUser.last_name}`
              //     : "Calling ..."
              // );
              setShowMessage(WAITING_ROOM_MESSAGE);

              // FIX: Set userName in callMetadata when initiating call (caller side)
              const userName = selectedUser?.first_name
                ? `${selectedUser.first_name} ${
                    selectedUser.last_name || ""
                  }`.trim()
                : "";

              // DEBUG: Log userName being saved to callMetadata (audio call initiation)

              setCallMetadata((prev) => ({
                ...prev,
                userName: userName,
                showMessage: WAITING_ROOM_MESSAGE,
                callType: "audio",
                sendingCall: true,
              }));

              // Clean up existing tracks before creating new ones
              if (channelParameters.localVideoTrack) {
                channelParameters.localVideoTrack.stop();
                channelParameters.localVideoTrack.close();
              }
              if (channelParameters.localAudioTrack) {
                channelParameters.localAudioTrack.stop();
                channelParameters.localAudioTrack.close();
              }

              await getAgoraEngine().join(
                options.appId,
                options.channel,
                options.token,
                options.uid
              );

              // Create a local audio track from the microphone audio.
              channelParameters.localAudioTrack =
                await AgoraRTC.createMicrophoneAudioTrack();
              // Publish the local audio track in the channel.
              await getAgoraEngine().publish(channelParameters.localAudioTrack);
            } catch (err) {
              consoleService("erron in send call response socket = ", err);
            }
          }
        );
    } catch (err) {
      await getAgoraEngine().leave();
      setCallLoading(false);
      consoleService("error in join fun = ", err);
    }
  }

  async function join_video_fun() {
    try {
      // STEP 1: Check if CALLER (me) is busy on another device
      // This prevents making calls when already in a call on another device

      setCallLoading(false);
      setVideoCallLoading(true);

      let myBusyStatus;
      try {
        myBusyStatus = await checkUserBusyStatus(userDetails._id);
      } catch (busyCheckError) {
        console.error("Failed to check my busy status:", busyCheckError);
        toast.error(BUSY_SESSION_MESSAGE, {
          autoClose: 3000,
        });
        setVideoCallLoading(false);
        return;
      }

      // If I am busy (calling/in call on another device), block this call
      if (myBusyStatus.is_busy) {
        toast.error(BUSY_SESSION_MESSAGE, {
          autoClose: 4000,
          toastId: `self-busy-${userDetails._id}`,
        });
        setVideoCallLoading(false);
        return; // STOP HERE - Don't proceed with call
      }

      // STEP 2: Check if RECEIVER is busy BEFORE initiating call
      let busyStatus;
      try {
        busyStatus = await checkUserBusyStatus(chat_id);
      } catch (busyCheckError) {
        console.error("Failed to check busy status:", busyCheckError);
        toast.error("Failed to check user availability. Please try again.", {
          autoClose: 3000,
        });
        setVideoCallLoading(false);
        return;
      }

      // If receiver is busy, show message and stop
      if (busyStatus.is_busy) {
        const selectedUser = users.find(
          (item) => item._id == chat_id || item.user_id == chat_id
        );
        const userName = selectedUser?.first_name
          ? `${selectedUser.first_name} ${selectedUser.last_name || ""}`.trim()
          : busyStatus.user_name || "User";

        const callTypeText =
          busyStatus.call_type === "video_call" ? "video" : "voice";

        toast.error(
          `${userName} is currently on another call. Please try again later.`,
          {
            autoClose: 4000,
            toastId: `busy-${chat_id}`,
          }
        );

        setVideoCallLoading(false);
        return; // STOP HERE - Don't proceed with call
      }

      // STEP 3: Check multi-tab (prevent multiple calls from different tabs)
      if (activeCallTabId && activeCallTabId !== tabId) {
        toast.error("A call is already active in another tab", {
          toastId: "call-in-another-tab",
          autoClose: 3000,
        });
        setVideoCallLoading(false);
        return;
      }

      // STEP 4: Check microphone access BEFORE initiating call
      // Quick permission check to prevent initiating call if microphone unavailable
      try {
        const testStream = await navigator.mediaDevices.getUserMedia({
          audio: true,
        });
        testStream.getTracks().forEach((track) => track.stop());
      } catch (error) {
        console.error("❌ Microphone check failed:", error.name);
        toast.error(
          "Microphone access is required for calls. Please check your microphone and permissions.",
          {
            position: "top-center",
            autoClose: 5000,
          }
        );
        setVideoCallLoading(false);
        return; // Stop here - don't initiate call
      }

      // Proceed with call setup
      setEndCallMessage("");
      const selectedUser = users.find(
        (item) => item._id == chat_id || item.user_id == chat_id
      );
      setSelectedUser(selectedUser); // Update global selectedUser for UI display
      const token = await get_agora_token(options.channel);
      options.token = token;
      options.caller_id = userDetails._id;
      options.patientDetails = userDetails;
      // Emit a message for video call
      socket &&
        socket.emit(
          "message",
          {
            from: userDetails._id,
            to: chat_id,
            type: "video_call",
            message: options,
            call_from: `${userDetails.first_name} ${userDetails.last_name}`,
            call_to: selectedUser.first_name
              ? `${selectedUser.first_name} ${selectedUser.last_name}`
              : "",
          },
          async (response) => {
            try {
              setRunningCallId(response.data.message_id);
              setCallType("video");

              // Mark this tab as the active caller
              setActiveCallTabId(tabId);
              setRemoteUserId(chat_id);

              // Broadcast to other tabs that this tab is making the call
              if (audioChannel) {
                audioChannel.postMessage({
                  type: "call_accepted_by_tab",
                  tabId: tabId,
                  payload: {
                    remoteUserId: chat_id,
                    callType: "video",
                  },
                });
              }

              setSendingCall(true);
              setIsCallInProcess(true);
              setIsInCall(true);
              setMuteAudio(false);
              setHideVideo(false);
              // setShowMessage(
              //   selectedUser?.first_name != undefined
              //     ? `Calling to ${selectedUser.first_name} ${selectedUser.last_name}`
              //     : "Calling ..."
              // );
              setShowMessage(WAITING_ROOM_MESSAGE);

              // FIX: Set userName in callMetadata when initiating call (caller side)
              const userName = selectedUser?.first_name
                ? `${selectedUser.first_name} ${
                    selectedUser.last_name || ""
                  }`.trim()
                : "";

              // DEBUG: Log userName being saved to callMetadata (video call initiation)

              setCallMetadata((prev) => ({
                ...prev,
                userName: userName,
                showMessage: WAITING_ROOM_MESSAGE,
                callType: "video",
                sendingCall: true,
              }));

              // NEW: Update unified call state
              updateCallState({
                status: "ringing_out",
                type: "video",
                role: "caller",
                chat_id: chat_id,
                remoteUserId: chat_id,
                message_id: response.data.message_id,
                user: {
                  _id: selectedUser?._id || chat_id,
                  first_name: selectedUser?.first_name || "",
                  last_name: selectedUser?.last_name || "",
                  profile_image: selectedUser?.profile_image || "",
                },
                showMessage: WAITING_ROOM_MESSAGE,
                isMuted: false,
                isVideoHidden: false,
                activeTabId: tabId,
              });

              // Clean up existing tracks before creating new ones
              if (channelParameters.localVideoTrack) {
                channelParameters.localVideoTrack.stop();
                channelParameters.localVideoTrack.close();
              }
              if (channelParameters.localAudioTrack) {
                channelParameters.localAudioTrack.stop();
                channelParameters.localAudioTrack.close();
              }

              await getAgoraEngine().join(
                options.appId,
                options.channel,
                options.token,
                options.uid
              );

              // Try to create audio and video tracks - handle failures gracefully
              let audioTrack = null;
              let videoTrack = null;

              // Try audio first (required)
              try {
                audioTrack = await AgoraRTC.createMicrophoneAudioTrack();
              } catch (audioError) {
                console.error(
                  "❌ Failed to create audio track:",
                  audioError.name,
                  audioError.message
                );
                // Audio is required - cannot proceed without microphone
                toast.error(
                  "Microphone access is required for calls. Please check your microphone and permissions.",
                  {
                    position: "top-center",
                    autoClose: 5000,
                  }
                );
                setVideoCallLoading(false);
                throw audioError; // Propagate error to stop call
              }

              // Try video (optional - can proceed without it)
              try {
                videoTrack = await AgoraRTC.createCameraVideoTrack({
                  encoderConfig: "360p_7",
                  optimizationMode: "detail",
                  facingMode: "user",
                });
              } catch (videoError) {
                console.warn(
                  "⚠️ Could not create video track:",
                  videoError.name,
                  videoError.message
                );
                // Video is optional - proceed with audio only
                videoTrack = null;

                // Only show camera notification if audio was successful
                if (audioTrack) {
                  // Add keyframes for smooth animations if not already added
                  if (!document.getElementById("tooltip-animations")) {
                    const style = document.createElement("style");
                    style.id = "tooltip-animations";
                    style.textContent = `
                      @keyframes tooltipFadeIn {
                        from {
                          opacity: 0;
                          transform: translateX(-50%) translateY(-10px);
                        }
                        to {
                          opacity: 1;
                          transform: translateX(-50%) translateY(0);
                        }
                      }
                      @keyframes tooltipFadeOut {
                        from {
                          opacity: 1;
                          transform: translateX(-50%) translateY(0);
                        }
                        to {
                          opacity: 0;
                          transform: translateX(-50%) translateY(-10px);
                        }
                      }
                    `;
                    document.head.appendChild(style);
                  }

                  // Show custom tooltip for camera unavailable
                  const tooltip = document.createElement("div");
                  tooltip.textContent =
                    "Camera unavailable. Continuing with audio only.";
                  tooltip.style.cssText = `
                    position: fixed;
                    top: 20px;
                    left: 50%;
                    transform: translateX(-50%);
                    background: #000000;
                    color: #ffffff;
                    padding: 10px 20px;
                    border-radius: 6px;
                    font-size: 14px;
                    font-weight: 500;
                    z-index: 10000;
                    box-shadow: 0 2px 8px rgba(0,0,0,0.3);
                    border: 1px solid #ffffff;
                    animation: tooltipFadeIn 0.4s ease-out;
                  `;
                  document.body.appendChild(tooltip);
                  setTimeout(() => {
                    tooltip.style.animation = "tooltipFadeOut 0.4s ease-in";
                    setTimeout(() => tooltip.remove(), 400);
                  }, 4000);
                }
              }

              // Store tracks
              channelParameters.localAudioTrack = audioTrack;
              channelParameters.localVideoTrack = videoTrack;
              localTracksRef.current.localAudioTrack = audioTrack;
              localTracksRef.current.localVideoTrack = videoTrack;

              if (channelParameters.localVideoTrack) {
                // Add delay to ensure DOM is ready and prevent blinking
                setTimeout(() => {
                  // Find the active video container (first one that exists)
                  const videoElement1 = document.getElementById(
                    "local-video-container-1"
                  );
                  const videoElement2 = document.getElementById(
                    "local-video-container-2"
                  );
                  const activeElement = videoElement1 || videoElement2;

                  if (activeElement && !activeElement.srcObject) {
                    channelParameters.localVideoTrack.play(activeElement.id);
                  }
                }, 100);
              }

              // Publish only available tracks
              const tracksToPublish = [];
              if (channelParameters.localAudioTrack) {
                tracksToPublish.push(channelParameters.localAudioTrack);
              }
              if (channelParameters.localVideoTrack) {
                tracksToPublish.push(channelParameters.localVideoTrack);
              }

              if (tracksToPublish.length > 0) {
                await getAgoraEngine().publish(tracksToPublish);
              }
            } catch (err) {
              consoleService("erron in send call response socket = ", err);
            }
          }
        );
    } catch (err) {
      await getAgoraEngine().leave();
      setVideoCallLoading(false);
      consoleService("error in join_video_fun: ", err);
    }
  }

  const acceptCallByPopupFun = async () => {
    // Check if another tab already accepted
    if (activeCallTabId && activeCallTabId !== tabId) {
      toast.error("Call is already active in another window", {
        toastId: "call-already-accepted",
        autoClose: 3000,
      });
      setCallLoading(false);
      return;
    }

    // Check if agoraMessage and message details are available
    if (!agoraMessage || !agoraMessage.message) {
      console.error(
        "Call information not available in agoraMessage:",
        agoraMessage
      );
      toast.error("Call information not available. Please try again.", {
        toastId: "call-info-missing",
        autoClose: 3000,
      });
      setCallLoading(false);
      return;
    }

    try {
      const hasPermissions = await requestAudioPermissions();
      if (!hasPermissions) {
        endCallByDefaultDueToPermission(agoraMessage.from);
        return;
      }
      await getAgoraEngine().leave();
    } catch {}
    try {
      setCallLoading(true);
      setVideoCallLoading(false);
      const details = agoraMessage.message;
      const callFrom = agoraMessage.call_from;

      // Store remote user ID
      setRemoteUserId(details.caller_id);

      await handle_select_user(null, details.caller_id);

      // Double-check that another tab hasn't accepted while we were getting permissions
      if (activeCallTabId && activeCallTabId !== tabId) {
        toast.info("Call was accepted in another window", {
          toastId: "call-accepted-during-permission",
          autoClose: 3000,
        });
        setCallLoading(false);
        return;
      }

      socket &&
        socket.emit(
          "message",
          {
            from: userDetails._id,
            to: details.caller_id,
            type: "voice_call",
            message_event_type: "accepted_voice_call",
            message: "",
            call_from: callFrom,
            call_to: `${userDetails.first_name} ${userDetails.last_name}`,
            message_id: get_running_call_id(),
          },
          async (response) => {
            try {
              if (!(response.status === 1)) {
                // Server rejected - another tab likely accepted first
                setCallLoading(false);
                toast.info("Call was accepted in another window", {
                  toastId: "call-accepted-elsewhere",
                  autoClose: 3000,
                });
                return;
              }

              // SUCCESS - This tab accepted the call
              setActiveCallTabId(tabId);

              // Broadcast to other tabs
              if (audioChannel) {
                audioChannel.postMessage({
                  type: "call_accepted_by_tab",
                  tabId: tabId,
                  payload: {
                    remoteUserId: details.caller_id,
                    callType: "audio",
                  },
                });
              }

              setReceiving(true);
              setHideVideo(false);
              setMuteAudio(false);

              // NEW: Update unified call state with caller information
              const callerUser = selectedUser || {};

              updateCallState({
                status: "active",
                type: "audio",
                role: "callee",
                chat_id: details.caller_id,
                remoteUserId: details.caller_id,
                user: {
                  _id: callerUser._id || details.caller_id,
                  first_name:
                    callerUser.first_name || callFrom.split(" ")[0] || "",
                  last_name:
                    callerUser.last_name || callFrom.split(" ")[1] || "",
                  profile_image: callerUser.profile_image || "",
                },
                message_id: get_running_call_id(),
                showMessage: callFrom,
                isMuted: false,
                isVideoHidden: false,
                activeTabId: tabId,
              });
              await getAgoraEngine().join(
                details.appId,
                details.channel,
                details.token,
                details.uid
              );
              channelParameters.localAudioTrack =
                await AgoraRTC.createMicrophoneAudioTrack();
              // Publish the local audio track in the channel.
              await getAgoraEngine().publish(channelParameters.localAudioTrack);
            } catch (err) {
              consoleService("erro in accept call socket = ", err);
            }
          }
        );
    } catch (err) {
      consoleService("error in acceptCallByPopupFun= ", err);

      // Check if error is because another tab accepted (activeCallTabId is set)
      if (activeCallTabId && activeCallTabId !== tabId) {
        // Another tab accepted - just clear loading
        setCallLoading(false);
        setVideoCallLoading(false);
      } else {
        // Real error (permissions denied, network error, etc.) - full cleanup
        setCallLoading(false);
        setVideoCallLoading(false);
        setSendingCall(false);
        setReceiving(false);
        seAcceptCallStatus(false);
        setIsCallInProcess(false);
        pauseAudio();

        // Show error to user
        toast.error("Failed to accept call. Please try again.", {
          autoClose: 3000,
        });
      }
    }
  };

  const acceptVideoCallByPopupFun = async () => {
    // Check if another tab already accepted
    if (activeCallTabId && activeCallTabId !== tabId) {
      toast.error("Call is already active in another window", {
        toastId: "call-already-accepted",
        autoClose: 3000,
      });
      setVideoCallLoading(false);
      return;
    }

    // Check if agoraMessage and message details are available
    if (!agoraMessage || !agoraMessage.message) {
      console.error(
        "Call information not available in agoraMessage:",
        agoraMessage
      );
      toast.error("Call information not available. Please try again.", {
        toastId: "call-info-missing",
        autoClose: 3000,
      });
      setVideoCallLoading(false);
      return;
    }

    // Check microphone access BEFORE accepting call
    // Quick permission check to prevent accepting call if microphone unavailable
    try {
      const testStream = await navigator.mediaDevices.getUserMedia({
        audio: true,
      });
      testStream.getTracks().forEach((track) => track.stop());
    } catch (error) {
      console.error("❌ Microphone check failed:", error.name);
      toast.error(
        "Microphone access is required for calls. Please check your microphone and permissions.",
        {
          position: "top-center",
          autoClose: 5000,
        }
      );
      setVideoCallLoading(false);
      return; // Stop here - don't accept call
    }

    try {
      // Note: No longer pre-checking permissions - we'll handle it when creating tracks
      await getAgoraEngine().leave();
    } catch {}
    try {
      setVideoCallLoading(true);
      setCallLoading(false);
      const details = agoraMessage.message;
      const callFrom = agoraMessage.call_from;

      // Store remote user ID
      setRemoteUserId(details.caller_id);

      await handle_select_user(null, details.caller_id);

      // Double-check that another tab hasn't accepted while we were getting permissions
      if (activeCallTabId && activeCallTabId !== tabId) {
        toast.info("Call was accepted in another window", {
          toastId: "call-accepted-during-permission",
          autoClose: 3000,
        });
        setVideoCallLoading(false);
        return;
      }

      socket &&
        socket.emit(
          "message",
          {
            from: userDetails._id,
            to: details.caller_id,
            type: "video_call",
            message_event_type: "accepted_video_call",
            message: "",
            call_from: callFrom,
            call_to: `${userDetails.first_name} ${userDetails.last_name}`,
            message_id: get_running_call_id(),
          },
          async (response) => {
            try {
              if (!(response.status === 1)) {
                // Server rejected - another tab likely accepted first
                setVideoCallLoading(false);
                toast.info("Call was accepted in another window", {
                  toastId: "call-accepted-elsewhere",
                  autoClose: 3000,
                });
                return;
              }

              // SUCCESS - This tab accepted the call
              setActiveCallTabId(tabId);

              // Broadcast to other tabs
              if (audioChannel) {
                audioChannel.postMessage({
                  type: "call_accepted_by_tab",
                  tabId: tabId,
                  payload: {
                    remoteUserId: details.caller_id,
                    callType: "video",
                  },
                });
              }

              setReceiving(true);
              setShowMessage(callFrom);

              // NEW: Update unified call state with caller information
              // Get the user info from selectedUser (populated by handle_select_user above)
              const callerUser = selectedUser || {};

              updateCallState({
                status: "active",
                type: "video",
                role: "callee",
                chat_id: details.caller_id,
                remoteUserId: details.caller_id,
                user: {
                  _id: callerUser._id || details.caller_id,
                  first_name:
                    callerUser.first_name || callFrom.split(" ")[0] || "",
                  last_name:
                    callerUser.last_name || callFrom.split(" ")[1] || "",
                  profile_image: callerUser.profile_image || "",
                },
                message_id: get_running_call_id(),
                showMessage: callFrom,
                isMuted: false,
                isVideoHidden: false,
                activeTabId: tabId,
              });

              setHideVideo(false);
              setMuteAudio(false);
              await getAgoraEngine().join(
                details.appId,
                details.channel,
                details.token,
                details.uid
              );

              // Try to create audio and video tracks - handle failures gracefully
              let audioTrack = null;
              let videoTrack = null;

              // Try audio first (required)
              try {
                audioTrack = await AgoraRTC.createMicrophoneAudioTrack();
              } catch (audioError) {
                console.error(
                  "❌ (Receiver) Failed to create audio track:",
                  audioError.name,
                  audioError.message
                );
                // Audio is required - cannot proceed without microphone
                toast.error(
                  "Microphone access is required for calls. Please check your microphone and permissions.",
                  {
                    position: "top-center",
                    autoClose: 5000,
                  }
                );
                setVideoCallLoading(false);
                throw audioError; // Propagate error to stop call
              }

              // Try video (optional - can proceed without it)
              try {
                videoTrack = await AgoraRTC.createCameraVideoTrack({
                  encoderConfig: "360p_7",
                  optimizationMode: "detail",
                  facingMode: "user",
                });
              } catch (videoError) {
                console.warn(
                  "⚠️ (Receiver) Could not create video track:",
                  videoError.name,
                  videoError.message
                );
                // Video is optional - proceed with audio only
                videoTrack = null;

                // Only show camera notification if audio was successful
                if (audioTrack) {
                  // Add keyframes for smooth animations if not already added
                  if (!document.getElementById("tooltip-animations")) {
                    const style = document.createElement("style");
                    style.id = "tooltip-animations";
                    style.textContent = `
                      @keyframes tooltipFadeIn {
                        from {
                          opacity: 0;
                          transform: translateX(-50%) translateY(-10px);
                        }
                        to {
                          opacity: 1;
                          transform: translateX(-50%) translateY(0);
                        }
                      }
                      @keyframes tooltipFadeOut {
                        from {
                          opacity: 1;
                          transform: translateX(-50%) translateY(0);
                        }
                        to {
                          opacity: 0;
                          transform: translateX(-50%) translateY(-10px);
                        }
                      }
                    `;
                    document.head.appendChild(style);
                  }

                  // Show custom tooltip for camera unavailable
                  const tooltip = document.createElement("div");
                  tooltip.textContent =
                    "Camera unavailable. Continuing with audio only.";
                  tooltip.style.cssText = `
                    position: fixed;
                    top: 20px;
                    left: 50%;
                    transform: translateX(-50%);
                    background: #000000;
                    color: #ffffff;
                    padding: 10px 20px;
                    border-radius: 6px;
                    font-size: 14px;
                    font-weight: 500;
                    z-index: 10000;
                    box-shadow: 0 2px 8px rgba(0,0,0,0.3);
                    border: 1px solid #ffffff;
                    animation: tooltipFadeIn 0.4s ease-out;
                  `;
                  document.body.appendChild(tooltip);
                  setTimeout(() => {
                    tooltip.style.animation = "tooltipFadeOut 0.4s ease-in";
                    setTimeout(() => tooltip.remove(), 400);
                  }, 4000);
                }
              }

              // Store tracks
              channelParameters.localAudioTrack = audioTrack;
              channelParameters.localVideoTrack = videoTrack;
              localTracksRef.current.localAudioTrack = audioTrack;
              localTracksRef.current.localVideoTrack = videoTrack;

              if (channelParameters.localVideoTrack) {
                // Add delay to ensure DOM is ready and prevent blinking
                setTimeout(() => {
                  // Find the active video container (first one that exists)
                  const videoElement1 = document.getElementById(
                    "local-video-container-1"
                  );
                  const videoElement2 = document.getElementById(
                    "local-video-container-2"
                  );
                  const activeElement = videoElement1 || videoElement2;

                  if (activeElement && !activeElement.srcObject) {
                    channelParameters.localVideoTrack.play(activeElement.id);
                  }
                }, 100);
              }

              // Publish only available tracks
              const tracksToPublish = [];
              if (channelParameters.localAudioTrack) {
                tracksToPublish.push(channelParameters.localAudioTrack);
              }
              if (channelParameters.localVideoTrack) {
                tracksToPublish.push(channelParameters.localVideoTrack);
              }

              if (tracksToPublish.length > 0) {
                await getAgoraEngine().publish(tracksToPublish);
              }
            } catch (err) {
              consoleService("erro in accept call socket = ", err);
            }
          }
        );
    } catch (err) {
      consoleService("error in acceptVideoCallByPopupFun =fun", err);

      // Check if error is because another tab accepted (activeCallTabId is set)
      if (activeCallTabId && activeCallTabId !== tabId) {
        // Another tab accepted - just clear loading
        setVideoCallLoading(false);
        setCallLoading(false);
      } else {
        // Real error (permissions denied, network error, etc.) - full cleanup
        setVideoCallLoading(false);
        setCallLoading(false);
        setSendingCall(false);
        setReceiving(false);
        seAcceptCallStatus(false);
        setIsCallInProcess(false);
        pauseAudio();

        // Show error to user
        toast.error("Failed to accept call. Please try again.", {
          autoClose: 3000,
        });
      }
    }
  };

  const endCallByCallerFun = async () => {
    // Prevent duplicate end calls
    if (isEndingCall) return;
    setIsEndingCall(true);

    const running_call_id = get_running_call_id();

    // Use remoteUserId (stored when call started) instead of chat_id
    // IMPORTANT: Get this BEFORE calling end_call_fun() which clears it
    // Fall back to callMetadata if state hasn't updated yet (after remount)
    const targetUserId =
      remoteUserId ||
      chat_id ||
      callMetadata.remoteUserId ||
      callMetadata.chat_id;

    if (!socket || !targetUserId) {
      console.error("Cannot end call: missing socket or target user ID", {
        socket: !!socket,
        remoteUserId,
        chat_id,
        callMetadataRemoteUserId: callMetadata?.remoteUserId,
        callMetadataChatId: callMetadata?.chat_id,
      });
      setIsEndingCall(false);
      return;
    }

    // Broadcast to other tabs that this tab is ending the call
    if (audioChannel) {
      audioChannel.postMessage({
        type: "call_ended_by_tab",
        tabId: tabId,
      });
    }

    // Send socket message BEFORE cleanup
    socket.emit("message", {
      from: userDetails._id,
      to: targetUserId,
      end_by: userDetails._id,
      message_event_type: "end_voice_call",
      type: "voice_call",
      call_status: "end",
      message_id: running_call_id,
      call_duration: getCallDuration(), // Use global duration from ref (no re-renders)
    });

    // Now cleanup local state
    end_call_fun();
  };

  const endVidioCallByCallerFun = async () => {
    // Prevent duplicate end calls
    if (isEndingCall) return;
    setIsEndingCall(true);

    const running_call_id = get_running_call_id();

    // Use remoteUserId (stored when call started) instead of chat_id
    // IMPORTANT: Get this BEFORE calling end_video_call_fun() which clears it
    // Fall back to callMetadata if state hasn't updated yet (after remount)
    const targetUserId =
      remoteUserId ||
      chat_id ||
      callMetadata.remoteUserId ||
      callMetadata.chat_id;

    if (!socket || !targetUserId) {
      console.error("Cannot end call: missing socket or target user ID", {
        socket: !!socket,
        remoteUserId,
        chat_id,
        callMetadataRemoteUserId: callMetadata?.remoteUserId,
        callMetadataChatId: callMetadata?.chat_id,
      });
      setIsEndingCall(false);
      return;
    }

    // Broadcast to other tabs that this tab is ending the call
    if (audioChannel) {
      audioChannel.postMessage({
        type: "call_ended_by_tab",
        tabId: tabId,
      });
    }

    // Send socket message BEFORE cleanup
    socket.emit("message", {
      from: userDetails._id,
      to: targetUserId,
      end_by: userDetails._id,
      message_event_type: "end_video_call",
      type: "video_call",
      call_status: "end",
      message_id: running_call_id,
      call_duration: getCallDuration(), // Use global duration from ref (no re-renders)
    });

    // Now cleanup local state
    end_video_call_fun();
  };

  const endCallByDefaultDueToPermission = async () => {
    try {
      const running_call_id = get_running_call_id();
      end_call_fun();
      if (!socket) return;
      socket.emit("message", {
        end_by: userDetails._id,
        message_event_type: "end_voice_call",
        type: "voice_call",
        call_status: "rejected",
        message_id: running_call_id,
      });
    } catch (err) {
      console.error(err);
    }
  };
  const endVideoCallByDefaultDueToPermission = async () => {
    try {
      const running_call_id = get_running_call_id();
      end_video_call_fun();
      if (!socket) return;

      socket.emit("message", {
        end_by: userDetails._id,
        message_event_type: "end_video_call",
        type: "video_call",
        call_status: "rejected",
        message_id: running_call_id,
      });
    } catch (err) {
      console.error(err);
    }
  };
  const endCallByReceiverFun = async () => {
    // Prevent duplicate end calls
    if (isEndingCall) return;
    setIsEndingCall(true);

    const running_call_id = get_running_call_id();

    // Use remoteUserId (stored when call started) instead of chat_id
    // IMPORTANT: Get this BEFORE calling end_call_fun() which clears it
    // Fall back to callMetadata if state hasn't updated yet (after remount)
    const targetUserId =
      remoteUserId ||
      chat_id ||
      callMetadata.remoteUserId ||
      callMetadata.chat_id;

    if (!socket || !targetUserId) {
      console.error("Cannot end call: missing socket or target user ID", {
        socket: !!socket,
        remoteUserId,
        chat_id,
        callMetadataRemoteUserId: callMetadata?.remoteUserId,
        callMetadataChatId: callMetadata?.chat_id,
      });
      setIsEndingCall(false);
      return;
    }

    // Broadcast to other tabs that this tab is ending the call
    if (audioChannel) {
      audioChannel.postMessage({
        type: "call_ended_by_tab",
        tabId: tabId,
      });
    }

    // Send socket message BEFORE cleanup
    socket.emit("message", {
      from: userDetails._id,
      to: targetUserId,
      end_by: userDetails._id,
      message_event_type: "end_voice_call",
      type: "voice_call",
      call_status: "end",
      message_id: running_call_id,
      call_duration: getCallDuration(), // Use global duration from ref (no re-renders)
    });

    // Now cleanup local state
    end_call_fun();
  };

  const endVideoCallByReceiverFun = async () => {
    // Prevent duplicate end calls
    if (isEndingCall) return;
    setIsEndingCall(true);

    const running_call_id = get_running_call_id();

    // Use remoteUserId (stored when call started) instead of chat_id
    // IMPORTANT: Get this BEFORE calling end_video_call_fun() which clears it
    // Fall back to callMetadata if state hasn't updated yet (after remount)
    const targetUserId =
      remoteUserId ||
      chat_id ||
      callMetadata.remoteUserId ||
      callMetadata.chat_id;

    if (!socket || !targetUserId) {
      console.error("Cannot end call: missing socket or target user ID", {
        socket: !!socket,
        remoteUserId,
        chat_id,
        callMetadataRemoteUserId: callMetadata?.remoteUserId,
        callMetadataChatId: callMetadata?.chat_id,
      });
      setIsEndingCall(false);
      return;
    }

    // Broadcast to other tabs that this tab is ending the call
    if (audioChannel) {
      audioChannel.postMessage({
        type: "call_ended_by_tab",
        tabId: tabId,
      });
    }

    // Send socket message BEFORE cleanup
    socket.emit("message", {
      from: userDetails._id,
      to: targetUserId,
      end_by: userDetails._id,
      message_event_type: "end_video_call",
      type: "video_call",
      call_status: "end",
      message_id: running_call_id,
      call_duration: getCallDuration(), // Use global duration from ref (no re-renders)
    });

    // Now cleanup local state
    end_video_call_fun();
  };

  const handle_select_user = async (e, chatId) => {
    setLoading(true);
    try {
      if (e) {
        e.preventDefault();
      }

      const res = await get_chat_history(chatId, chatPage);
      const appointment_res = IsTherapist
        ? await get_upcoming_appointment_of_specific_user(chatId)
        : await get_upcoming_appointment_of_specific_user_for_patient(chatId);
      if (res.status === 1 && appointment_res.status === 1) {
        setMessages([...res.data.reverse()]);
        setWindowClass("backHideShow");
        setFocus(!focus);
        setChat_id(chatId);
        selectedChat_user.current = chatId;
        const lastIndex = [res.data.length - 1];

        res.data.length > 0 &&
          socket &&
          socket.emit("check_id", {
            sender: res.data[lastIndex].from,
            receiver: res.data[lastIndex].to,
          });
        chatRef.current = chatId;
        if (Object.keys(appointment_res.data).length) {
          setChatStartTime(appointment_res.data.time);
          setChartEndTime(appointment_res.data.end_time);
        } else {
          setChatStartTime("");
          setChartEndTime("");
        }

        // NEW: Persist last selected user to localStorage for restoration on re-entry
        try {
          localStorage.setItem(
            `lastSelectedChatUser_${userDetails._id}`,
            chatId
          );
        } catch (storageErr) {
          console.warn("Failed to save last selected user:", storageErr);
        }

        setLoading(false);
      }
    } catch (err) {
      consoleService("error in handle_select_user", err);
    }
  };

  const send_message = () => {
    try {
      if (message.trim()) {
        setSendMessageLoading(true);
        socket &&
          socket.emit("message", {
            from: userDetails._id,
            to: chat_id,
            type: "message",
            message: message,
          });
        setMessage("");
      }
    } catch (err) {
      consoleService("error in send message fun = ", err);
    }
  };

  const preserveScrollPosition = (messageLength) => {
    if (scroll.current) {
      const newMessagesHeight = messageLength * 80;
      const newScrollPosition = scroll.current.scrollTop + newMessagesHeight;

      setScrollPosition(newScrollPosition);
    }
  };

  const loadmore_chat = async (scrolledNum) => {
    if (scrolledNum == 0 && !chatLoading) {
      setChatLoading(true);
      try {
        const msgs = messages;

        const total_message = msgs.length;
        const limit = 20;

        const divided_val = total_message / limit;

        let pageNumber = Math.ceil(divided_val);

        const isDecimal = divided_val % 1 !== 0;

        if (!isDecimal) {
          pageNumber += 1;
        }

        const res = await get_chat_history(chat_id, pageNumber);

        if (res.status === 1) {
          if (!res.data.length) {
            setChatLoading(false);
            return;
          }
          const newMessages = res.data;
          const finalMsgs = [];

          newMessages.forEach((item) => {
            const isFoundId = msgs.some((msgObj) => msgObj._id === item._id);
            if (!isFoundId) {
              finalMsgs.push(item);
            }
          });
          if (finalMsgs.length) {
            preserveScrollPosition(finalMsgs.length);
            const updatedMessages = [...finalMsgs.reverse(), ...msgs];

            setMessages([...updatedMessages]);
            setBySubmitMessage(false);
          }
          setChatLoading(false);
        }
      } catch (err) {
        consoleService("err in loadmore chat =", err);
        setChatLoading(false);
      }
    }
  };

  async function loadmore_users() {
    try {
      if (all_chat_user_loaded) return;
      const limit = 10;
      const total_users = users.length;
      const divided_val = total_users / limit;

      let pageNumber = Math.ceil(divided_val);

      const isDecimal = divided_val % 1 !== 0;

      if (!isDecimal) {
        pageNumber += 1;
      }

      setUserLoading(true);
      const res = await fetch_communicated_client_list(pageNumber);
      if (res.status === 1) {
        if (res.data.length) {
          const newUsers = res.data;

          const final_users = [];

          newUsers.forEach((item) => {
            const isFoundId = users.some(
              (userObj) => userObj.user_id === item.user_id
            );
            if (!isFoundId) {
              final_users.push(item);
            }
          });

          if (final_users.length) {
            const newData = [];
            final_users.forEach((item) => {
              if (item.user_id != chat_id) {
                newData.push(item);
              }
            });

            setUsers([...users, ...newData]);
            usersRef.current = [...users, ...newData];
            setUserLoading(false);
            const current_page = pageNumber;
            const totalItems = total_chat_users;
            const totalPages = Math.ceil(totalItems / limit);
            const isMoreItemsLeft = current_page < totalPages;
            if (!isMoreItemsLeft) {
              setAllChatUserLoaded(true);
              return;
            }
          }
        }
      }
    } catch (err) {
      setUserLoading(false);
      consoleService("err in loadmore_users =", err);
    }
  }

  const send_image = async (files) => {
    try {
      if (files.length > 0) {
        const file = files[0];
        const imageTypeRegex = /image\/(jpg|jpeg|png|heic)/gm;
        const isMatch =
          file.type.match(imageTypeRegex) || file.name.endsWith(".heic");
        const convertToArray = file.name.split(".");

        if (isMatch) {
          setSendMessageLoading(true);

          let processedFile = file;
          let fileFormat = convertToArray[convertToArray.length - 1];

          if (file.type === "image/heic" || file.name.endsWith(".heic")) {
            try {
              const blob = await heic2any({
                blob: file,
                toType: "image/jpeg",
                quality: 0.8,
              });
              processedFile = new File(
                [blob],
                file.name.replace(".heic", ".jpg"),
                { type: "image/jpeg" }
              );
              fileFormat = "jpg"; // Update file format
            } catch (error) {
              consoleService("HEIC conversion failed:", error);
              toast(
                "Failed to process HEIC image. Please upload a JPG or PNG instead.",
                {
                  position: "top-center",
                  hideProgressBar: true,
                  type: "error",
                }
              );
              setSendMessageLoading(false);
              return;
            }
          }

          const reader = new FileReader();
          reader.onload = (e) => {
            const base64Image = e.target.result.split(";base64,").pop();
            socket &&
              socket.emit("message", {
                from: userDetails._id,
                to: chat_id,
                type: "image",
                message: "",
                image_src: base64Image,
                file_format: fileFormat,
              });
          };

          reader.readAsDataURL(processedFile);
        } else {
          toast("Please select a file in JPG, PNG, HEIC, or JPEG format.", {
            position: "top-center",
            hideProgressBar: true,
            type: "error",
          });
          setSendMessageLoading(false);
        }
      }
    } catch (err) {
      setSendMessageLoading(false);
      consoleService("error in send_image fun = ", err);
    }
  };

  async function fetch_communicated_clients() {
    setLoading(true);
    try {
      if (navigateFrom == "upcoming") {
        const userDetails = IsTherapist
          ? preselectedUser.patient_details
          : preselectedUser.therapist_details;
        let selectedUser = {
          user_id: userDetails._id,
          profile_img: userDetails.profile_img,
          first_name: userDetails.first_name,
          last_name: userDetails.last_name,
          last_message: "",
          time: preselectedUser.time,
          unread_count: 0,
          online_status: true,
        };
        const res = await fetch_communicated_client_list(1);
        if (res.status === 1) {
          const fetchedData = res.data;

          const filteredData = [];

          fetchedData.forEach((item) => {
            if (item.user_id != userDetails._id) {
              filteredData.push(item);
            } else {
              selectedUser = item;
            }
          });

          setSelectedUser(selectedUser);

          setUsers([selectedUser, ...filteredData]);
          usersRef.current = [selectedUser, ...filteredData];
          setInitialLoading(true);
          setLoading(false);
        }
      } else {
        const res = await fetch_communicated_client_list(1);
        if (res.status === 1) {
          setUsers([...res.data]);
          usersRef.current = [...res.data];
          setInitialLoading(true);
          setLoading(false);
        }
      }
      const total_users_response = await fetch_total_chat_users();

      if (total_users_response.status == 1) {
        setTotalChatUsers(total_users_response.data.users_length);
      }
    } catch (err) {
      consoleService("error in fetch_communicated_client_list fun = ", err);
      setLoading(false);
    }
  }

  function isTimeDisabled(item) {
    return !checkActiveTimeSlots(item.time, item.end_time);
  }

  const delete_chat_fun = async () => {
    setLoading(true);
    try {
      const res = await delete_chat({
        del_id: chat_id,
      });
      if (res.status === 1) {
        const isAgoraMessageFound = Object.keys(agoraMessage).length > 0;
        if (isAgoraMessageFound) {
          const isChatIdExistInAgoraMessage =
            agoraMessage.from == chat_id || agoraMessage.to == chat_id;
          if (isChatIdExistInAgoraMessage) {
            setAgoraMessage({});
          }
        }

        const find_user_index = users.findIndex(
          (item) => item.user_id == chat_id
        );

        if (find_user_index >= 0) {
          const old_list = [...users];
          old_list.splice(find_user_index, 1);
          setUsers([...old_list]);
          usersRef.current = [...old_list];
        }

        setMessages([]);

        setChat_id("");
        setLoading(false);
      }
    } catch (err) {
      consoleService("error in delet chat function", err);
    }
  };

  const set_video_call_mute_unmute = async () => {
    if (isMuteLoading) return; // Prevent double-click

    try {
      setIsMuteLoading(true);

      // NEW: Check if we're reconnecting
      const engine = getAgoraEngine();
      if (
        engine.connectionState === "RECONNECTING" ||
        engine.connectionState === "DISCONNECTED"
      ) {
        setShowMessage("Please wait while reconnecting...");
        setTimeout(() => setShowMessage(""), 2000);
        setIsMuteLoading(false);
        return;
      }

      // Use local ref instead of channelParameters
      const audioTrack =
        localTracksRef.current.localAudioTrack ||
        channelParameters.localAudioTrack;

      if (audioTrack) {
        // Toggle mute state
        const newMuteState = !mute_audio;

        // Use setMuted for audio (preserves track state)
        await audioTrack.setMuted(newMuteState);

        // Update UI state after successful mute/unmute
        setMuteAudio(newMuteState);

        // Update call metadata for PiP window
        setCallMetadata((prev) => ({ ...prev, mute_audio: newMuteState }));

        // NEW: Update unified call state
        updateCallState({ isMuted: newMuteState });
      }
    } catch (err) {
      consoleService("err in set_video_call_mute_unmute =", err);
      setShowMessage("Failed to toggle audio");
      setTimeout(() => setShowMessage(""), 2000);
    } finally {
      setIsMuteLoading(false);
    }
  };

  const set_hide_unhide_video_fun = async () => {
    if (isVideoLoading) return; // Prevent double-click

    try {
      setIsVideoLoading(true);

      // NEW: Check if we're reconnecting
      const engine = getAgoraEngine();
      if (
        engine.connectionState === "RECONNECTING" ||
        engine.connectionState === "DISCONNECTED"
      ) {
        setShowMessage("Please wait while reconnecting...");
        setTimeout(() => setShowMessage(""), 2000);
        setIsVideoLoading(false);
        return;
      }

      // Use local ref instead of channelParameters
      const videoTrack =
        localTracksRef.current.localVideoTrack ||
        channelParameters.localVideoTrack;

      if (videoTrack) {
        const newHideState = !hide_video;

        // FIX: Use setEnabled instead of unpublish/publish to avoid interruption
        // This keeps the track published but disables transmission
        await videoTrack.setEnabled(!newHideState);

        // Handle local video visibility
        if (isCallMinimized) {
          // In PiP mode - replay to PiP element after publishing
          if (!newHideState) {
            setTimeout(() => {
              const floatingElement = document.getElementById(
                "floating-local-video"
              );
              if (floatingElement) {
                videoTrack.play("floating-local-video");
              }
            }, 100);
          }
        } else {
          // In main screen - manipulate DOM elements
          const localVideoElement =
            document.getElementById("local-video-container-1") ||
            document.getElementById("local-video-container-2");
          if (localVideoElement) {
            localVideoElement.style.opacity = newHideState ? "0" : "1";
            localVideoElement.style.pointerEvents = newHideState
              ? "none"
              : "auto";
          }

          // Cover with black div
          let coverDiv = document.getElementById("video-cover");
          if (!coverDiv && newHideState) {
            coverDiv = document.createElement("div");
            coverDiv.id = "video-cover";
            coverDiv.style.position = "absolute";
            coverDiv.style.width = "160px";
            coverDiv.style.height = "120px";
            coverDiv.style.backgroundColor = "black";
            coverDiv.style.bottom = "10px";
            coverDiv.style.right = "10px";
            coverDiv.style.zIndex = "23";
            coverDiv.style.borderRadius = "10px";
            localVideoElement.parentElement.appendChild(coverDiv);
          } else if (coverDiv) {
            coverDiv.style.display = newHideState ? "block" : "none";
          }
        }

        setHideVideo(newHideState);

        // Update call metadata for PiP window
        setCallMetadata((prev) => ({ ...prev, hide_video: newHideState }));

        // NEW: Update unified call state
        updateCallState({ isVideoHidden: newHideState });
      }
    } catch (err) {
      consoleService("error in set_hide_unhide_video_fun =", err);
      setShowMessage("Failed to toggle video");
      setTimeout(() => setShowMessage(""), 2000);
    } finally {
      setIsVideoLoading(false);
    }
  };

  // Handle PiP - Move call to floating PiP window
  const handleMinimize = () => {
    try {
      debugLog.entry("handleMinimize", {
        isInCall,
        isCallMinimized,
        sendingCall,
        receivingCall,
        callType,
        mute_audio,
        hide_video,
        callDuration: getCallDuration(),
      });

      // Get actual tracks from refs (more reliable than channelParameters)
      // IMPORTANT: If callMetadata already has tracks (from previous minimize), preserve them!
      // This prevents tracks from becoming null when handleMinimize is called again (e.g., clicking messages)
      const localVideo =
        localTracksRef.current.localVideoTrack ||
        channelParameters.localVideoTrack ||
        callMetadata.localVideoTrack; // Fallback to existing
      const remoteVideo =
        remoteTracksRef.current.remoteVideoTrack ||
        channelParameters.remoteVideoTrack ||
        callMetadata.remoteVideoTrack; // Fallback to existing
      const localAudio =
        localTracksRef.current.localAudioTrack ||
        channelParameters.localAudioTrack ||
        callMetadata.localAudioTrack; // Fallback to existing
      const remoteAudio =
        remoteTracksRef.current.remoteAudioTrack ||
        channelParameters.remoteAudioTrack ||
        callMetadata.remoteAudioTrack; // Fallback to existing

      debugLog("handleMinimize_tracks", {
        hasLocalVideo: !!localVideo,
        hasRemoteVideo: !!remoteVideo,
        hasLocalAudio: !!localAudio,
        hasRemoteAudio: !!remoteAudio,
      });

      // Update call metadata for PiP window with actual track references
      // FIX: Use unifiedCallState.user as fallback for userName to persist across navigation
      // ENHANCED FIX: If we have an existing name in metadata, preserve it (even if isCallMinimized is false due to remount)
      let userNameForPip;

      // If callMetadata already has a userName (from previous minimize or remount), preserve it
      // This handles both: (1) already minimized calls, and (2) after navigation/remount
      if (callMetadata.userName && callMetadata.userName.trim() !== "") {
        userNameForPip = callMetadata.userName;
      } else {
        // First time minimizing - calculate userName using fallback chain
        userNameForPip = selectedUser?.first_name
          ? `${selectedUser.first_name} ${selectedUser.last_name || ""}`.trim()
          : unifiedCallState.user?.first_name
          ? `${unifiedCallState.user.first_name} ${
              unifiedCallState.user.last_name || ""
            }`.trim()
          : ""; // Don't use callMetadata.userName here since we already checked it's empty
      }

      // DEBUG: Log call type being saved to callMetadata during minimize

      // FIX: Don't save "Calling..." or waiting room messages for active calls
      // If call is active (accepted), show empty message or "In call"
      const isWaitingMessage = showMessage && (
        showMessage.includes("Calling") ||
        showMessage.includes("Please wait")
      );
      const messageToSave = (acceptCallStatus || receivingCall || sendingCall) && isWaitingMessage
        ? "" // Clear waiting messages for active calls
        : showMessage;

      setCallMetadata({
        callType: callType,
        sendingCall: sendingCall,
        receivingCall: receivingCall,
        mute_audio: mute_audio,
        hide_video: hide_video,
        showMessage: messageToSave,
        callDuration: getCallDuration(), // Use global duration from AuthContext
        localVideoTrack: localVideo,
        remoteVideoTrack: remoteVideo,
        localAudioTrack: localAudio,
        remoteAudioTrack: remoteAudio,
        chat_id: chat_id, // Save for ending calls after remount
        remoteUserId: remoteUserId, // Save for ending calls after remount
        userName: userNameForPip, // Save user name for display with fallback chain
      });

      // NEW: Also update unified call state with complete data
      updateCallState({
        isMinimized: true,
        isMuted: mute_audio,
        isVideoHidden: hide_video,
        // duration is already being tracked globally, no need to update it here
        tracks: {
          localVideo: localVideo,
          remoteVideo: remoteVideo,
          localAudio: localAudio,
          remoteAudio: remoteAudio,
        },
        // Ensure user and appointment data are preserved
        chat_id: chat_id || unifiedCallState.chat_id,
        remoteUserId: remoteUserId || unifiedCallState.remoteUserId,
        user: selectedUser?._id
          ? {
              _id: selectedUser._id,
              first_name: selectedUser.first_name || "",
              last_name: selectedUser.last_name || "",
              profile_image: selectedUser.profile_image || "",
            }
          : unifiedCallState.user,
      });

      // Set minimized state - FloatingWindow will auto-play tracks
      setIsCallMinimized(true);

      debugLog.exit("handleMinimize", {
        success: true,
        userNameSaved: userNameForPip,
        callMetadataSaved: {
          callType: callType,
          sendingCall,
          receivingCall,
        },
      });
    } catch (err) {
      debugLog.error("handleMinimize", err);
      consoleService("error in handleMinimize =", err);
    }
  };

  // Handle Exit PiP - Restore call to main window
  const handleExpand = () => {
    try {
      debugLog.entry("handleExpand", {
        isInCall,
        isCallMinimized,
        sendingCall,
        receivingCall,
        callMetadata: {
          sendingCall: callMetadata?.sendingCall,
          receivingCall: callMetadata?.receivingCall,
          callType: callMetadata?.callType,
          callDuration: callMetadata?.callDuration,
          showMessage: callMetadata?.showMessage,
        },
        globalDuration: getCallDuration(),
      });

      setIsCallMinimized(false);

      // NOTE: No need to restore call duration - it's tracked globally in AuthContext ref
      // Duration continues counting even during navigation and PiP (ref-based, no re-renders)

      // ============================================================================
      // 🔧 FIX: Restore mute/video states from unifiedCallState or callMetadata
      // When expanding from PiP, we need to restore the toggle button states
      // ============================================================================
      const savedMuteState = unifiedCallState.isMuted ?? callMetadata.mute_audio ?? false;
      const savedVideoState = unifiedCallState.isVideoHidden ?? callMetadata.hide_video ?? false;

      debugLog.info("handleExpand", "Restoring mute/video states", {
        savedMuteState,
        savedVideoState,
        fromUnifiedState: unifiedCallState.isMuted !== undefined,
        fromCallMetadata: callMetadata.mute_audio !== undefined,
      });

      setMuteAudio(savedMuteState);
      setHideVideo(savedVideoState);

      // FIX: Clear "Calling..." message or restore saved message status
      // If the saved message was a status message (not a temporary error), clear it
      // Otherwise, restore it (e.g., for network quality warnings)
      if (callMetadata?.showMessage) {
        // Only restore non-calling status messages
        const isCallingMessage = callMetadata.showMessage === "Calling...";
        if (!isCallingMessage) {
          debugLog.info("handleExpand", "Restoring showMessage", {
            message: callMetadata.showMessage,
          });
          setShowMessage(callMetadata.showMessage);
        } else {
          debugLog.info("handleExpand", 'Clearing "Calling..." message');
          setShowMessage("");
        }
      } else {
        // No saved message - clear any existing message
        setShowMessage("");
      }

      // FIX: Restore call state if call is active but sendingCall/receivingCall are false
      // This happens after appointment expiry or page navigation
      if (isInCall && !sendingCall && !receivingCall) {
        debugLog.warn(
          "handleExpand",
          "Call active but sendingCall/receivingCall are false - restoring states"
        );

        // Check callMetadata to determine which state to restore
        if (callMetadata?.sendingCall) {
          debugLog.info("handleExpand", "Restoring sendingCall state");
          setSendingCall(true);
        } else if (callMetadata?.receivingCall) {
          debugLog.info("handleExpand", "Restoring receivingCall state");
          setReceiving(true);
        } else {
          // Fallback: If callMetadata doesn't have the info, use a heuristic
          // If we have remote tracks, assume we're in an accepted call (receiving)
          const hasRemoteTracks =
            remoteTracksRef.current.remoteVideoTrack ||
            remoteTracksRef.current.remoteAudioTrack ||
            callMetadata.remoteVideoTrack ||
            callMetadata.remoteAudioTrack;

          if (hasRemoteTracks) {
            debugLog.info(
              "handleExpand",
              "Fallback: Restoring receivingCall based on remote tracks"
            );
            setReceiving(true);
          } else {
            debugLog.info(
              "handleExpand",
              "Fallback: Restoring sendingCall as default"
            );
            setSendingCall(true);
          }
        }

        // Also ensure acceptCallStatus is true for active calls
        if (!acceptCallStatus) {
          debugLog.info("handleExpand", "Setting acceptCallStatus to true");
          seAcceptCallStatus(true);
        }
      }

      // Force React to re-render UI components (fixes UI not showing after session timeout)
      setForceRenderKey((prev) => prev + 1);

      // Use tracks from refs (local source of truth)
      const localVideo =
        localTracksRef.current.localVideoTrack || callMetadata.localVideoTrack;
      const remoteVideo =
        remoteTracksRef.current.remoteVideoTrack ||
        callMetadata.remoteVideoTrack;

      // Use callMetadata.callType as primary, fallback to local callType
      const currentCallType = callMetadata.callType || callType;
      const isVideoCall = currentCallType === "video";

      debugLog("handleExpand", {
        currentCallType,
        isVideoCall,
        hasLocalVideo: !!localVideo,
        hasRemoteVideo: !!remoteVideo,
      });

      if (isVideoCall && (localVideo || remoteVideo)) {
        setTimeout(() => {
          if (localVideo) {
            const localElement =
              document.getElementById("local-video-container-1") ||
              document.getElementById("local-video-container-2");
            if (localElement) {
              debugLog.info("handleExpand", "Playing local video", {
                elementId: localElement.id,
              });
              localVideo.play(localElement.id);
            } else {
              debugLog.error("handleExpand", "Local video element not found");
            }
          }

          if (remoteVideo) {
            const remoteContainer = document.getElementById("video-container");
            if (remoteContainer) {
              debugLog.info("handleExpand", "Playing remote video");
              remoteVideo.play("video-container");
            } else {
              debugLog.error(
                "handleExpand",
                "Remote video container not found"
              );
            }
          }
        }, 200);
      }

      debugLog.exit("handleExpand", { success: true });
    } catch (err) {
      debugLog.error("handleExpand", err);
      consoleService("error in handleExpand:", err);
    }
  };

  // Enhanced Video UI Functions

  // Network Quality Helper
  const getNetworkQualityInfo = (quality) => {
    switch (quality) {
      case 0:
      case 1:
        return {
          icon: <SignalCellularAlt />,
          color: "#4caf50",
          label: "Excellent",
        };
      case 2:
        return { icon: <SignalCellularAlt />, color: "#8bc34a", label: "Good" };
      case 3:
        return {
          icon: <SignalCellular1Bar />,
          color: "#ff9800",
          label: "Poor",
        };
      case 4:
        return { icon: <SignalCellular1Bar />, color: "#ff5722", label: "Bad" };
      case 5:
      case 6:
        return {
          icon: <SignalCellular0Bar />,
          color: "#f44336",
          label: "Very Bad",
        };
      default:
        return {
          icon: <SignalCellularAlt />,
          color: "#9e9e9e",
          label: "Unknown",
        };
    }
  };

  ///////////////////////////////////////////// MAIN RETURN //////////////////////////////////////////////

  return (
    <div>
      <div className="breadHidePhone">
        <BannerSection banner={Banner} name={"Home"} title={"Chat"} />
      </div>
      <section className="py-5 useraccount bg-light_dash">
        <div className="container">
          <div className="row">
            <div
              className={`col-xl-3 col-md-4 ${
                filterHideShow ? "leftShow" : "leftHide"
              }`}
            >
              <TherapistSidebar />
            </div>
            <div className="col-xl-9 col-md-8 fulltabBox mb-2">
              <div className="filterBox">
                <Link className="filterIcon" onClick={sideBarHide}>
                  <FaAlignLeft />
                </Link>
              </div>
              {endCallMessage && (
                <div className="endCallTimer">
                  Call will end in: {endCallMessage}
                </div>
              )}
              <div className={`chat-window ${window_class}`}>
                <div className="chat-cont-left">
                  <div className="chat-users-list">
                    <div
                      className="chat-scroll user_list_chat_scroll"
                      ref={users_scroll}
                      onScroll={() => {
                        if (users_scroll.current) {
                          const container = users_scroll.current;
                          const isAtEnd =
                            container.scrollTop + container.clientHeight ===
                            container.scrollHeight;
                          if (isAtEnd && !userLoading) {
                            loadmore_users();
                          }
                        }
                      }}
                    >
                      {/* USER LIST */}

                      {users.length
                        ? initial_loading &&
                          users.map((item, index) => {
                            const user_name = `${item.first_name} ${item.last_name}`;

                            const isDeletedByUser = IsTherapist
                              ? item.therapist_del_status
                              : item.patient_del_status;

                            return (
                              <Link
                                as="button"
                                onClick={(e) => {
                                  // FIX: Don't overwrite selectedUser if in an active call
                                  // PiP is using selectedUser/unifiedCallState for caller name
                                  if (!isInCall && !isCallInProcess) {
                                    setSelectedUser(item);
                                  } else {
                                  }
                                  handle_select_user(e, item.user_id);
                                }}
                                className="media d-flex active"
                                style={{
                                  backgroundColor:
                                    item.user_id == chat_id ? "#1d7e7c" : "",
                                }}
                                key={index}
                              >
                                <div className="media-img-wrap flex-shrink-0">
                                  <div className="avatar avatar-away">
                                    <UserAvatar
                                      profileImage={item.profile_img}
                                      firstName={item.first_name || item.name}
                                      lastName={item.last_name}
                                      size="lg"
                                      className="avatar-lg rounded-circle"
                                      alt={`${item.first_name} ${item.last_name}`}
                                    />
                                  </div>{" "}
                                  {}
                                </div>
                                <div className="media-body flex-grow-1">
                                  <div>
                                    <div
                                      className="user-name"
                                      style={{
                                        color:
                                          item.user_id == chat_id
                                            ? "#fff"
                                            : "#000",
                                      }}
                                    >
                                      {user_name.slice(0, 14)}
                                      {user_name.length > 14 && "..."}
                                    </div>
                                    <div
                                      className="user-last-chat truncated-text "
                                      style={{ width: 130 }}
                                    >
                                      {!isDeletedByUser ? (
                                        item.message_from == userDetails._id ? (
                                          item.type == "voice_call" ? (
                                            `You: 📞 Call`
                                          ) : item.type == "video_call" ? (
                                            <>
                                              You:{" "}
                                              <VideocamOutlinedIcon
                                                style={{
                                                  width: 20,
                                                  height: 20,
                                                  color: "black",
                                                }}
                                              />{" "}
                                              Call
                                            </>
                                          ) : item.type == "image" ? (
                                            <>
                                              You:{" "}
                                              <ImageIcon
                                                style={{
                                                  width: 20,
                                                  height: 20,
                                                  color: "black",
                                                }}
                                              />
                                            </>
                                          ) : (
                                            `You: ${item.last_message}`
                                          )
                                        ) : (
                                          <span
                                            style={{
                                              color:
                                                item.user_id == chat_id
                                                  ? "#fff"
                                                  : "#000",
                                              fontWeight:
                                                item.unread_count > 0
                                                  ? "bold"
                                                  : "normal",
                                            }}
                                          >
                                            {item.type == "voice_call" ? (
                                              `📞 Call`
                                            ) : item.type == "video_call" ? (
                                              <>
                                                <VideocamOutlinedIcon
                                                  style={{
                                                    width: 20,
                                                    height: 20,
                                                    color: "black",
                                                  }}
                                                />{" "}
                                                Call
                                              </>
                                            ) : item.type == "image" ? (
                                              <>
                                                <ImageIcon
                                                  style={{
                                                    width: 20,
                                                    height: 20,
                                                    color: "black",
                                                  }}
                                                />
                                              </>
                                            ) : (
                                              item.last_message
                                            )}
                                          </span>
                                        )
                                      ) : (
                                        ""
                                      )}
                                    </div>
                                  </div>
                                  <div>
                                    <div
                                      className="last-chat-time block d-flex flex-column align-items-end"
                                      style={{
                                        fontSize: 9,
                                        color:
                                          item.user_id == chat_id
                                            ? "#fff"
                                            : "#000",
                                      }}
                                    >
                                      {item.time.trim() &&
                                        get_upcoming_timp_diff(
                                          item.time,
                                          item.time
                                        )}

                                      {item.unread_count > 0 &&
                                        item.message_from !=
                                          userDetails._id && (
                                          <Badge bg="danger">
                                            {item.unread_count}
                                          </Badge>
                                        )}
                                    </div>
                                  </div>
                                </div>
                              </Link>
                            );
                          })
                        : initial_loading && (
                            <div className="no_user chat_user_list_no_user">
                              No User Found
                            </div>
                          )}
                      {userLoading && (
                        <div className="newLOader">
                          <ReactLoader
                            type="ping-cube"
                            bgColor={"#1d7e7c"}
                            size={50}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="bbtnHide">
                  <Link
                    className="backToUsers"
                    onClick={() => {
                      handle_back_press();
                    }}
                  >
                    <FaChevronCircleLeft size={25} color="black" />
                  </Link>
                </div>
                {/* CHAT  */}

                {chat_id ? (
                  <>
                    <div className="chat-cont-right chat_cont-height">
                      <div className="d-flex align-items-center justify-content-end w-100">
                        {isChatDisableCondition && !isCallInProcess && (
                          <div className="liveLink">
                            {/* <Link
                              disabled={isDisableAudioCallIcon}
                              onClick={() => {
                                if (isInCall) {
                                  toast.warning("You are already in a call", {
                                    position: "top-center",
                                    autoClose: 2000,
                                  });
                                  return;
                                }
                                if (!isDisableAudioCallIcon) {
                                  join_chat_fun();
                                }
                              }}
                              className={`loader_Css ${
                                callLoading ? "phone_css" : ""
                              }`}
                            >
                              {callLoading ? (
                                <ReactLoader
                                  type="bubble-ping"
                                  bgColor={"black"}
                                  size={30}
                                />
                              ) : (
                                <FaPhoneAlt />
                              )}
                            </Link> */}

                            <Link
                              as="button"
                              disabled={isDisableVideoCallIcon}
                              onClick={() => {
                                if (isInCall) {
                                  toast.warning("You are already in a call", {
                                    position: "top-center",
                                    autoClose: 2000,
                                  });
                                  return;
                                }
                                if (!isDisableVideoCallIcon) {
                                  join_video_fun();
                                }
                              }}
                              className={`loader_Css ${
                                videoCallLoading ? "phone_css" : ""
                              }`}
                            >
                              {videoCallLoading ? (
                                <ReactLoader
                                  type="bubble-ping"
                                  bgColor={"black"}
                                  size={30}
                                />
                              ) : (
                                <FaVideo />
                              )}
                            </Link>
                          </div>
                        )}
                        <Button
                          variant="danger"
                          size="sm"
                          className="me-3 delDanger"
                          onClick={() => {
                            if (!isDisableDeleteChatIcon) {
                              delete_chat_fun();
                            }
                          }}
                        >
                          <FaTrashAlt />
                        </Button>
                      </div>

                      <div className="chat-body chat_body_div">
                        <div
                          className="chat-scroll"
                          ref={scroll}
                          onScroll={() => {
                            if (scroll.current) {
                              loadmore_chat(scroll.current.scrollTop);
                            }
                          }}
                        >
                          {chatLoading && (
                            <div className="newLOader">
                              <ReactLoader
                                type="ping-cube"
                                bgColor={"#1d7e7c"}
                                size={50}
                              />
                            </div>
                          )}

                          <ul className="list-unstyled">
                            {messages.length === 0 &&
                            isChatDisableCondition &&
                            window_class === "backHideShow" ? (
                              <li className="welcome-message-item">
                                <div className="welcome-message-box">
                                  <p
                                    style={{
                                      textAlign: "center",
                                      padding: "20px",
                                      color: "#666",
                                    }}
                                  >
                                    {WELCOME_MESSAGE}
                                  </p>
                                </div>
                              </li>
                            ) : (
                              messages.map((item, index) => {
                                const isDeletedByUser = IsTherapist
                                  ? item.therapist_del_status
                                  : item.patient_del_status;

                                let call_message = "";
                                const item_type = item.type;
                                const isVoiceCall = item_type == "voice_call";
                                const isVideoCall = item_type == "video_call";
                                if (isVoiceCall || isVideoCall) {
                                  const callStatus = item.call_status;
                                  switch (callStatus) {
                                    case "not_answered":
                                      call_message = isVoiceCall
                                        ? "📞 Missed Call"
                                        : "Missed Call";
                                      break;
                                    case "rejected":
                                      call_message = isVoiceCall
                                        ? "📞 Rejected"
                                        : "Rejected";
                                      break;
                                    case "end":
                                      call_message = `${
                                        isVoiceCall
                                          ? "📞 Call duration"
                                          : "Call duration"
                                      } : ${getConversationTime(
                                        item.call_start_time,
                                        item.call_end_time
                                      )}`;

                                      break;
                                    default:
                                      call_message = "";
                                  }
                                }

                                if (item.from != userDetails._id) {
                                  return (
                                    <li
                                      key={index}
                                      className="media received d-flex"
                                    >
                                      {!isDeletedByUser && (
                                        <>
                                          <div className="avatar flex-shrink-0">
                                            <UserAvatar
                                              profileImage={
                                                item.from_user_profile_img
                                              }
                                              firstName={
                                                item.from_user_first_name ||
                                                item.from_user_name
                                              }
                                              lastName={
                                                item.from_user_last_name
                                              }
                                              size="sm"
                                              className="rounded-circle"
                                              alt={`${item.from_user_first_name} ${item.from_user_last_name}`}
                                              style={{
                                                width: "32px",
                                                height: "32px",
                                              }}
                                            />
                                          </div>
                                          <div className="media-body flex-grow-1">
                                            <div className="msg-box">
                                              <div>
                                                {item.type == "message" ? (
                                                  <p>{item.message}</p>
                                                ) : item.type ==
                                                  "voice_call" ? (
                                                  <p>{call_message}</p>
                                                ) : item.type ==
                                                  "video_call" ? (
                                                  <p>
                                                    <VideocamOutlinedIcon
                                                      style={{
                                                        width: 20,
                                                        height: 20,
                                                        color: "white",
                                                      }}
                                                    />{" "}
                                                    {call_message}
                                                  </p>
                                                ) : (
                                                  <>
                                                    {item.type == "image" && (
                                                      <div className="chat-container">
                                                        <a
                                                          href={`${ConstConfig.IMAGE_URL}${item.image_src}`}
                                                          target="_blank"
                                                        >
                                                          <img
                                                            className="chat-image"
                                                            src={`${ConstConfig.IMAGE_URL}${item.image_src}`}
                                                          />
                                                        </a>
                                                      </div>
                                                    )}
                                                  </>
                                                )}

                                                <ul className="chat-msg-info">
                                                  <li>
                                                    <div className="chat-time">
                                                      <span>
                                                        {get_chat_time(
                                                          item.created_at
                                                        )}
                                                      </span>
                                                    </div>
                                                  </li>
                                                </ul>
                                              </div>
                                            </div>
                                          </div>
                                        </>
                                      )}
                                    </li>
                                  );
                                } else {
                                  return (
                                    <li
                                      key={index}
                                      className="media sent d-flex"
                                    >
                                      {!isDeletedByUser && (
                                        <>
                                          <div className="avatar flex-shrink-0">
                                            <UserAvatar
                                              profileImage={
                                                item.from_user_profile_img
                                              }
                                              firstName={
                                                item.from_user_first_name ||
                                                item.from_user_name
                                              }
                                              lastName={
                                                item.from_user_last_name
                                              }
                                              size="sm"
                                              className="rounded-circle"
                                              alt={`${item.from_user_first_name} ${item.from_user_last_name}`}
                                              style={{
                                                width: "32px",
                                                height: "32px",
                                              }}
                                            />
                                          </div>
                                          <div className="media-body flex-grow-1">
                                            <div className="msg-box">
                                              <div>
                                                {item.type == "message" ? (
                                                  <p>{item.message}</p>
                                                ) : item.type ==
                                                  "voice_call" ? (
                                                  <p>{call_message}</p>
                                                ) : item.type ==
                                                  "video_call" ? (
                                                  <p>
                                                    <VideocamOutlinedIcon
                                                      style={{
                                                        width: 20,
                                                        height: 20,
                                                        color: "black",
                                                      }}
                                                    />{" "}
                                                    {call_message}
                                                  </p>
                                                ) : (
                                                  <>
                                                    {item.type == "image" && (
                                                      <div className="chat-container">
                                                        <a
                                                          href={`${ConstConfig.IMAGE_URL}${item.image_src}`}
                                                          target="_blank"
                                                        >
                                                          <img
                                                            className="chat-image"
                                                            src={`${ConstConfig.IMAGE_URL}${item.image_src}`}
                                                          />
                                                        </a>
                                                      </div>
                                                    )}
                                                  </>
                                                )}
                                                <ul className="chat-msg-info">
                                                  <li>
                                                    <div className="chat-time">
                                                      <span>
                                                        {get_chat_time(
                                                          item.created_at
                                                        )}
                                                      </span>
                                                    </div>
                                                  </li>
                                                </ul>
                                              </div>
                                            </div>
                                          </div>
                                        </>
                                      )}
                                    </li>
                                  );
                                }
                              })
                            )}
                          </ul>
                        </div>
                      </div>

                      {chat_id &&
                        chat_start_time &&
                        chat_end_time &&
                        !isTimeDisabled({
                          time: chat_start_time,
                          end_time: chat_end_time,
                        }) && (
                          <div className="chat-footer">
                            <div>
                              <Link
                                as="button"
                                onClick={(e) => {
                                  e.preventDefault();
                                }}
                              >
                                <FaPaperclip />
                              </Link>

                              <input
                                type="file"
                                accept="image/jpg, image/jpeg, image/png, image/heic"
                                className="chat-doc-selector"
                                multiple={false}
                                disabled={send_message_loading}
                                value={""}
                                onChange={(e) => {
                                  send_image(e.target.files);
                                }}
                              />
                            </div>

                            <div className="input-group">
                              <input
                                type="text"
                                className="input-msg-send form-control"
                                placeholder="Message..."
                                value={message}
                                onChange={(e) => {
                                  if (send_message_loading) return;
                                  setMessage(e.target.value.trimStart());
                                }}
                                onKeyDown={(e) => {
                                  if (
                                    !send_message_loading &&
                                    e.key == "Enter"
                                  ) {
                                    send_message();
                                  }
                                }}
                              />

                              <button
                                disabled={!message || send_message_loading}
                                type="button"
                                className="btn btn-primary msg-send-btn rounded-pill"
                                onClick={() => {
                                  send_message();
                                }}
                              >
                                {send_message_loading ? (
                                  <ReactLoader
                                    type="bubble-loop"
                                    bgColor={"white"}
                                    size={25}
                                  />
                                ) : (
                                  <FaPaperPlane />
                                )}
                              </button>
                            </div>
                          </div>
                        )}
                      <></>
                    </div>

                    {sendingCall &&
                    (!activeCallTabId || activeCallTabId === tabId) ? (
                      isAudioCall ? (
                        <div
                          className="chat-cont-right"
                          style={{
                            display: isCallMinimized ? "none" : "block",
                          }}
                        >
                          <VoiceCallScreen
                            message={showMessage}
                            onEndCall={endCallByCallerFun}
                            role={"caller"}
                            isAccept={acceptCallStatus}
                            onMinimize={handleMinimize}
                            userName={(() => {
                              const userName = selectedUser?.first_name
                                ? `${selectedUser.first_name} ${
                                    selectedUser.last_name || ""
                                  }`.trim()
                                : callMetadata?.userName || ""; // Fallback to saved name after re-login

                              // DEBUG: Log userName calculation for caller

                              return userName;
                            })()}
                          />
                        </div>
                      ) : isVideoCall ? (
                        <div
                          className="fixedVvideo"
                          style={{
                            flex: 1,
                            display: isCallMinimized ? "none" : "block",
                          }}
                        >
                          <div
                            style={{
                              position: "absolute",
                              top: "50%",
                              left: "50%",
                              transform: "translate(-50%, -50%)",
                              zIndex: 2,
                              display: "flex",
                              flexDirection: "column",
                              justifyContent: "center",
                              alignItems: "center",
                              width: "65%",
                            }}
                          >
                            {!acceptCallStatus && (
                              <>
                                <VideocamOutlinedIcon
                                  style={{
                                    width: 60,
                                    height: 60,
                                    color: "white",
                                    marginBottom: 10,
                                  }}
                                />
                                <div
                                  className={`call-status in-call`}
                                  style={{
                                    fontSize: isMobile ? "11px" : "13px", // Reduced font size
                                    padding: isMobile ? "0 10px" : "0", // Add padding on mobile for better text wrap
                                    textAlign: "center", // Center the text
                                    width: "100%", // Full width for proper centering
                                  }}
                                >
                                  {showMessage}
                                </div>
                              </>
                            )}
                          </div>

                          {/* Enhanced Bottom Control Bar with All Controls */}
                          <Box
                            sx={{
                              position: "fixed",
                              bottom: 20,
                              left: "50%",
                              transform: "translateX(-50%)",
                              zIndex: 1000,
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",
                              gap: 1,
                            }}
                          >
                            {/* Main Control Bar */}
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 1,
                                p: 1.5,
                                borderRadius: 4,
                                backgroundColor: "rgba(0,0,0,0.85)",
                                backdropFilter: "blur(25px)",
                                border: "1px solid rgba(255, 255, 255, 0.15)",
                                boxShadow: "0 10px 40px rgba(0,0,0,0.5)",
                              }}
                            >
                              {/* Microphone */}
                              <Tooltip
                                title={mute_audio ? "Unmute" : "Mute"}
                                placement="top"
                                disableInteractive
                              >
                                <IconButton
                                  onClick={() => set_video_call_mute_unmute()}
                                  sx={{
                                    backgroundColor: mute_audio
                                      ? "rgba(244, 67, 54, 0.2)"
                                      : "rgba(255, 255, 255, 0.1)",
                                    color: mute_audio ? "#f44336" : "white",
                                    border: mute_audio
                                      ? "1px solid #f44336"
                                      : "1px solid rgba(255, 255, 255, 0.2)",
                                    "&:hover": {
                                      backgroundColor: mute_audio
                                        ? "rgba(244, 67, 54, 0.3)"
                                        : "rgba(255, 255, 255, 0.2)",
                                    },
                                    width: 42,
                                    height: 42,
                                    marginRight: 1,
                                  }}
                                >
                                  {mute_audio ? <MicOff /> : <Mic />}
                                </IconButton>
                              </Tooltip>

                              {/* Camera */}
                              <Tooltip
                                title={
                                  hide_video
                                    ? "Turn on camera"
                                    : "Turn off camera"
                                }
                                placement="top"
                                disableInteractive
                              >
                                <IconButton
                                  onClick={async () =>
                                    set_hide_unhide_video_fun()
                                  }
                                  sx={{
                                    backgroundColor: hide_video
                                      ? "rgba(244, 67, 54, 0.2)"
                                      : "rgba(255, 255, 255, 0.1)",
                                    color: hide_video ? "#f44336" : "white",
                                    border: hide_video
                                      ? "1px solid #f44336"
                                      : "1px solid rgba(255, 255, 255, 0.2)",
                                    "&:hover": {
                                      backgroundColor: hide_video
                                        ? "rgba(244, 67, 54, 0.3)"
                                        : "rgba(255, 255, 255, 0.2)",
                                    },
                                    width: 42,
                                    height: 42,
                                  }}
                                >
                                  {hide_video ? <VideocamOff /> : <Videocam />}
                                </IconButton>
                              </Tooltip>

                              <Box
                                sx={{
                                  width: 1,
                                  height: 25,
                                  backgroundColor: "rgba(255,255,255,0.1)",
                                }}
                              />

                              {/* Network Quality Indicator */}
                              {(callLoading || videoCallLoading) && (
                                <Tooltip
                                  title={`Network: ${
                                    getNetworkQualityInfo(
                                      Math.max(
                                        networkQuality.uplink,
                                        networkQuality.downlink
                                      )
                                    ).label
                                  }`}
                                  placement="top"
                                  disableInteractive
                                >
                                  <Box
                                    sx={{
                                      display: "flex",
                                      alignItems: "center",
                                      gap: 0.5,
                                      px: 1,
                                      py: 0.5,
                                      borderRadius: 2,
                                      backgroundColor: isNetworkPoor
                                        ? "rgba(255, 152, 0, 0.1)"
                                        : "rgba(255, 255, 255, 0.05)",
                                      border: `1px solid ${
                                        getNetworkQualityInfo(
                                          Math.max(
                                            networkQuality.uplink,
                                            networkQuality.downlink
                                          )
                                        ).color
                                      }30`,
                                    }}
                                  >
                                    <Box
                                      sx={{
                                        color: getNetworkQualityInfo(
                                          Math.max(
                                            networkQuality.uplink,
                                            networkQuality.downlink
                                          )
                                        ).color,
                                      }}
                                    >
                                      {
                                        getNetworkQualityInfo(
                                          Math.max(
                                            networkQuality.uplink,
                                            networkQuality.downlink
                                          )
                                        ).icon
                                      }
                                    </Box>
                                    {isNetworkPoor && (
                                      <Typography
                                        variant="caption"
                                        sx={{
                                          color: "#ff9800",
                                          fontWeight: "bold",
                                        }}
                                      >
                                        Poor
                                      </Typography>
                                    )}
                                  </Box>
                                </Tooltip>
                              )}

                              {/* Picture-in-Picture */}
                              <Tooltip
                                title="Picture-in-Picture"
                                placement="top"
                                disableInteractive
                              >
                                <IconButton
                                  onClick={handleMinimize}
                                  sx={{
                                    backgroundColor: "rgba(255, 255, 255, 0.1)",
                                    color: "white",
                                    border:
                                      "1px solid rgba(255, 255, 255, 0.2)",
                                    "&:hover": {
                                      backgroundColor:
                                        "rgba(255, 255, 255, 0.2)",
                                    },
                                    width: 42,
                                    height: 42,
                                  }}
                                >
                                  <PictureInPictureAlt />
                                </IconButton>
                              </Tooltip>

                              <Box
                                sx={{
                                  width: 1,
                                  height: 25,
                                  backgroundColor: "rgba(255,255,255,0.1)",
                                }}
                              />

                              {/* End Call */}
                              <Tooltip
                                title="End call"
                                placement="top"
                                disableInteractive
                              >
                                <IconButton
                                  onClick={() => {
                                    if (sendingCall) {
                                      endVidioCallByCallerFun();
                                    } else {
                                      endVideoCallByReceiverFun();
                                    }
                                  }}
                                  sx={{
                                    backgroundColor: "#f44336",
                                    color: "white",
                                    "&:hover": {
                                      backgroundColor: "#d32f2f",
                                    },
                                    width: 42,
                                    height: 42,
                                  }}
                                >
                                  <CallEnd />
                                </IconButton>
                              </Tooltip>
                            </Box>
                          </Box>

                          <video
                            id="video-container"
                            controls={false}
                            style={{
                              background:
                                "linear-gradient(45deg, #000000, #666666, #000000, #333333)",
                              backgroundSize: "400% 400%",
                              animation: "gradientShift 8s ease infinite",
                              height: "100%",
                              width: "100%",
                              objectFit: "contain",
                            }}
                          ></video>
                          {/* Enhanced Draggable & Resizable Local Video */}
                          <Draggable
                            position={localVideoPosition}
                            onStop={(e, data) =>
                              setLocalVideoPosition({ x: data.x, y: data.y })
                            }
                            bounds="parent"
                            cancel=".react-resizable-handle" // Prevent drag when resizing
                          >
                            <ResizableBox
                              width={localVideoSize.width}
                              height={localVideoSize.height}
                              minConstraints={isMobile ? [100, 75] : [120, 90]}
                              maxConstraints={
                                isMobile ? [240, 180] : [480, 360]
                              } // Responsive max size
                              lockAspectRatio={true} // Maintain 4:3 aspect ratio
                              resizeHandles={
                                hide_video ? [] : ["se", "sw", "ne", "nw"]
                              } // Hide resize handles when video disabled
                              onResize={(e, data) => {
                                setLocalVideoSize(data.size);
                                // Immediately update video element size
                                setTimeout(() => {
                                  const videoElement =
                                    document.getElementById(
                                      "local-video-container-1"
                                    ) ||
                                    document.getElementById(
                                      "local-video-container-2"
                                    );
                                  if (videoElement) {
                                    videoElement.style.width = `${data.size.width}px`;
                                    videoElement.style.height = `${data.size.height}px`;
                                  }
                                }, 0);
                              }}
                              style={{
                                position: "absolute",
                                bottom: isMobile ? 100 : 10, // Set to 100px on mobile as per your testing
                                right: 10,
                                zIndex: 22,
                                background: "black",
                                borderRadius: "30px",
                              }}
                              handleSize={[20, 20]} // Larger handles for mobile
                            >
                              <Paper
                                elevation={0}
                                className="professional-video-container"
                                sx={{
                                  position: "relative",
                                  width: "100%",
                                  height: "100%",
                                  borderRadius: "12px",
                                  overflow: "hidden",
                                  background:
                                    "linear-gradient(145deg, rgba(20, 20, 25, 0.95) 0%, rgba(40, 40, 45, 0.9) 50%, rgba(20, 20, 25, 0.95) 100%)",
                                  border: "1px solid rgba(255, 255, 255, 0.1)",
                                  cursor: "move",
                                  backdropFilter: "blur(10px)",
                                  boxShadow: `
                                    0 10px 30px -5px rgba(0, 0, 0, 0.5),
                                    0 0 0 1px rgba(255, 255, 255, 0.05),
                                    inset 0 1px 0 0 rgba(255, 255, 255, 0.1)
                                  `,
                                  "&:hover": {
                                    boxShadow: `
                                      0 15px 40px -5px rgba(0, 0, 0, 0.6),
                                      0 0 0 1px rgba(255, 255, 255, 0.1),
                                      inset 0 1px 0 0 rgba(255, 255, 255, 0.15)
                                    `,
                                    border:
                                      "1px solid rgba(255, 255, 255, 0.15)",
                                  },
                                  transition: "all 0.3s ease",
                                  // Mobile-friendly touch area
                                  touchAction: "none",
                                  userSelect: "none",
                                }}
                              >
                                {/* Professional Name Badge */}
                                <Box
                                  sx={{
                                    position: "absolute",
                                    top: 8,
                                    left: 8,
                                    zIndex: 27,
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 0.5,
                                    padding: "3px 8px",
                                    borderRadius: "20px",
                                    background: "rgba(0, 0, 0, 0.7)",
                                    backdropFilter: "blur(10px)",
                                    border:
                                      "1px solid rgba(255, 255, 255, 0.1)",
                                  }}
                                >
                                  <Box
                                    sx={{
                                      width: 6,
                                      height: 6,
                                      borderRadius: "50%",
                                      background: "#4CAF50",
                                      animation: "pulse 2s infinite",
                                      "@keyframes pulse": {
                                        "0%": { opacity: 1 },
                                        "50%": { opacity: 0.5 },
                                        "100%": { opacity: 1 },
                                      },
                                    }}
                                  />
                                  <Typography
                                    variant="caption"
                                    sx={{
                                      color: "rgba(255, 255, 255, 0.9)",
                                      fontSize: "9px",
                                      fontWeight: 500,
                                      letterSpacing: "0.3px",
                                    }}
                                  >
                                    You
                                  </Typography>
                                </Box>

                                {/* Video Element */}
                                <video
                                  ref={localVideoRef1}
                                  id="local-video-container-1"
                                  controls={false}
                                  autoPlay
                                  playsInline
                                  muted
                                  style={{
                                    width: "100%",
                                    height: "100%",
                                    objectFit: "cover",
                                    transform: "scaleX(-1)",
                                    borderRadius: "10px",
                                    pointerEvents: "none", // Allow drag through video
                                  }}
                                ></video>
                              </Paper>
                            </ResizableBox>
                          </Draggable>
                        </div>
                      ) : (
                        <></>
                      )
                    ) : null}

                    {receivingCall &&
                    (!activeCallTabId || activeCallTabId === tabId) ? (
                      isAudioCall ? (
                        <div
                          className="chat-cont-right"
                          style={{
                            display: isCallMinimized ? "none" : "block",
                          }}
                        >
                          <VoiceCallScreen
                            message={showMessage}
                            onEndCall={endCallByReceiverFun}
                            role={"receiver"}
                            isAccept={acceptCallStatus}
                            onMinimize={handleMinimize}
                            userName={(() => {
                              const userName = selectedUser?.first_name
                                ? `${selectedUser.first_name} ${
                                    selectedUser.last_name || ""
                                  }`.trim()
                                : callMetadata?.userName || ""; // Fallback to saved name after re-login

                              // DEBUG: Log userName calculation for receiver

                              return userName;
                            })()}
                          />
                        </div>
                      ) : isVideoCall ? (
                        <div
                          className="fixedVvideo"
                          style={{
                            flex: 1,
                            display: isCallMinimized ? "none" : "block",
                          }}
                        >
                          <div
                            style={{
                              position: "absolute",
                              top: "50%",
                              left: "50%",
                              transform: "translate(-50%, -50%)",
                              zIndex: 2,
                              display: "flex",
                              flexDirection: "column",
                              justifyContent: "center",
                              alignItems: "center",
                              width: "65%",
                            }}
                          >
                            {!acceptCallStatus && (
                              <>
                                <VideocamOutlinedIcon
                                  style={{
                                    width: 60,
                                    height: 60,
                                    color: "white",
                                    marginBottom: 10,
                                  }}
                                />
                              </>
                            )}
                          </div>

                          {/* Enhanced Bottom Control Bar with All Controls - Receiver */}
                          <Box
                            sx={{
                              position: "fixed",
                              bottom: 20,
                              left: "50%",
                              transform: "translateX(-50%)",
                              zIndex: 1000,
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",
                              gap: 1,
                            }}
                          >
                            {/* Main Control Bar */}
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 1.5,
                                p: 1.5,
                                borderRadius: 4,
                                backgroundColor: "rgba(0,0,0,0.7)",
                                backdropFilter: "blur(15px)",
                                border: "1px solid rgba(255, 255, 255, 0.1)",
                              }}
                            >
                              {/* Mute/Unmute Button */}
                              <Tooltip
                                title={mute_audio ? "Unmute" : "Mute"}
                                placement="top"
                                disableInteractive
                              >
                                <IconButton
                                  onClick={() => set_video_call_mute_unmute()}
                                  sx={{
                                    backgroundColor: mute_audio
                                      ? "rgba(244, 67, 54, 0.2)"
                                      : "rgba(255, 255, 255, 0.1)",
                                    color: mute_audio ? "#f44336" : "white",
                                    border: mute_audio
                                      ? "1px solid #f44336"
                                      : "1px solid rgba(255, 255, 255, 0.2)",
                                    "&:hover": {
                                      backgroundColor: mute_audio
                                        ? "rgba(244, 67, 54, 0.3)"
                                        : "rgba(255, 255, 255, 0.2)",
                                    },
                                    width: 42,
                                    height: 42,
                                    marginRight: 1,
                                  }}
                                >
                                  {mute_audio ? <MicOff /> : <Mic />}
                                </IconButton>
                              </Tooltip>

                              {/* Video Toggle Button */}
                              <Tooltip
                                title={
                                  hide_video
                                    ? "Turn on camera"
                                    : "Turn off camera"
                                }
                                placement="top"
                                disableInteractive
                              >
                                <IconButton
                                  onClick={() => set_hide_unhide_video_fun()}
                                  sx={{
                                    backgroundColor: hide_video
                                      ? "rgba(244, 67, 54, 0.2)"
                                      : "rgba(255, 255, 255, 0.1)",
                                    color: hide_video ? "#f44336" : "white",
                                    border: hide_video
                                      ? "1px solid #f44336"
                                      : "1px solid rgba(255, 255, 255, 0.2)",
                                    "&:hover": {
                                      backgroundColor: hide_video
                                        ? "rgba(244, 67, 54, 0.3)"
                                        : "rgba(255, 255, 255, 0.2)",
                                    },
                                    width: 42,
                                    height: 42,
                                  }}
                                >
                                  {hide_video ? <VideocamOff /> : <Videocam />}
                                </IconButton>
                              </Tooltip>

                              <Box
                                sx={{
                                  width: 1,
                                  height: 25,
                                  backgroundColor: "rgba(255,255,255,0.1)",
                                }}
                              />

                              {/* Network Quality Indicator */}
                              {(callLoading || videoCallLoading) && (
                                <Tooltip
                                  title={`Network: ${
                                    getNetworkQualityInfo(
                                      Math.max(
                                        networkQuality.uplink,
                                        networkQuality.downlink
                                      )
                                    ).label
                                  }`}
                                  placement="top"
                                  disableInteractive
                                >
                                  <Box
                                    sx={{
                                      display: "flex",
                                      alignItems: "center",
                                      gap: 0.5,
                                      px: 1,
                                      py: 0.5,
                                      borderRadius: 2,
                                      backgroundColor: isNetworkPoor
                                        ? "rgba(255, 152, 0, 0.1)"
                                        : "rgba(255, 255, 255, 0.05)",
                                      border: `1px solid ${
                                        getNetworkQualityInfo(
                                          Math.max(
                                            networkQuality.uplink,
                                            networkQuality.downlink
                                          )
                                        ).color
                                      }30`,
                                    }}
                                  >
                                    <Box
                                      sx={{
                                        color: getNetworkQualityInfo(
                                          Math.max(
                                            networkQuality.uplink,
                                            networkQuality.downlink
                                          )
                                        ).color,
                                      }}
                                    >
                                      {
                                        getNetworkQualityInfo(
                                          Math.max(
                                            networkQuality.uplink,
                                            networkQuality.downlink
                                          )
                                        ).icon
                                      }
                                    </Box>
                                    {isNetworkPoor && (
                                      <Typography
                                        variant="caption"
                                        sx={{
                                          color: "#ff9800",
                                          fontWeight: "bold",
                                        }}
                                      >
                                        Poor
                                      </Typography>
                                    )}
                                  </Box>
                                </Tooltip>
                              )}

                              {/* Picture-in-Picture */}
                              <Tooltip
                                title="Picture-in-Picture"
                                placement="top"
                                disableInteractive
                              >
                                <IconButton
                                  onClick={handleMinimize}
                                  sx={{
                                    backgroundColor: "rgba(255, 255, 255, 0.1)",
                                    color: "white",
                                    border:
                                      "1px solid rgba(255, 255, 255, 0.2)",
                                    "&:hover": {
                                      backgroundColor:
                                        "rgba(255, 255, 255, 0.2)",
                                    },
                                    width: 42,
                                    height: 42,
                                  }}
                                >
                                  <PictureInPictureAlt />
                                </IconButton>
                              </Tooltip>

                              <Box
                                sx={{
                                  width: 1,
                                  height: 25,
                                  backgroundColor: "rgba(255,255,255,0.1)",
                                }}
                              />

                              {/* End Call Button */}
                              <Tooltip
                                title="End call"
                                placement="top"
                                disableInteractive
                              >
                                <IconButton
                                  onClick={() => endVideoCallByReceiverFun()}
                                  sx={{
                                    backgroundColor: "#f44336",
                                    color: "white",
                                    "&:hover": {
                                      backgroundColor: "#d32f2f",
                                    },
                                    width: 42,
                                    height: 42,
                                  }}
                                >
                                  <CallEnd />
                                </IconButton>
                              </Tooltip>
                            </Box>
                          </Box>
                          <video
                            id="video-container"
                            controls={false}
                            style={{
                              background:
                                "linear-gradient(45deg, #000000, #666666, #000000, #333333)",
                              backgroundSize: "400% 400%",
                              animation: "gradientShift 8s ease infinite",
                              height: "100%",
                              width: "100%",
                              objectFit: "contain",
                            }}
                          ></video>
                          {/* Enhanced Draggable & Resizable Local Video */}
                          <Draggable
                            position={localVideoPosition}
                            onStop={(e, data) =>
                              setLocalVideoPosition({ x: data.x, y: data.y })
                            }
                            bounds="parent"
                            cancel=".react-resizable-handle" // Prevent drag when resizing
                          >
                            <ResizableBox
                              width={localVideoSize.width}
                              height={localVideoSize.height}
                              minConstraints={[120, 90]}
                              maxConstraints={[480, 360]} // Larger max for desktop
                              lockAspectRatio={true} // Maintain 4:3 aspect ratio
                              resizeHandles={
                                hide_video ? [] : ["se", "sw", "ne", "nw"]
                              } // Hide resize handles when video disabled
                              onResize={(e, data) => {
                                setLocalVideoSize(data.size);
                                // Immediately update video element size
                                setTimeout(() => {
                                  const videoElement =
                                    document.getElementById(
                                      "local-video-container-1"
                                    ) ||
                                    document.getElementById(
                                      "local-video-container-2"
                                    );
                                  if (videoElement) {
                                    videoElement.style.width = `${data.size.width}px`;
                                    videoElement.style.height = `${data.size.height}px`;
                                  }
                                }, 0);
                              }}
                              style={{
                                position: "absolute",
                                bottom: isMobile ? 100 : 10, // Set to 100px on mobile as per your testing
                                right: 10,
                                zIndex: 22,
                                background: "black",
                                borderRadius: "30px",
                              }}
                              handleSize={[20, 20]} // Larger handles for mobile
                            >
                              <Paper
                                elevation={0}
                                className="professional-video-container"
                                sx={{
                                  position: "relative",
                                  width: "100%",
                                  height: "100%",
                                  borderRadius: "12px",
                                  overflow: "hidden",
                                  background:
                                    "linear-gradient(145deg, rgba(20, 20, 25, 0.95) 0%, rgba(40, 40, 45, 0.9) 50%, rgba(20, 20, 25, 0.95) 100%)",
                                  border: "1px solid rgba(255, 255, 255, 0.1)",
                                  cursor: "move",
                                  backdropFilter: "blur(10px)",
                                  boxShadow: `
                                  0 10px 30px -5px rgba(0, 0, 0, 0.5),
                                  0 0 0 1px rgba(255, 255, 255, 0.05),
                                  inset 0 1px 0 0 rgba(255, 255, 255, 0.1)
                                `,
                                  "&:hover": {
                                    boxShadow: `
                                    0 15px 40px -5px rgba(0, 0, 0, 0.6),
                                    0 0 0 1px rgba(255, 255, 255, 0.1),
                                    inset 0 1px 0 0 rgba(255, 255, 255, 0.15)
                                  `,
                                    border:
                                      "1px solid rgba(255, 255, 255, 0.15)",
                                  },
                                  transition: "all 0.3s ease",
                                  // Mobile-friendly touch area
                                  touchAction: "none",
                                  userSelect: "none",
                                }}
                              >
                                {/* Professional Name Badge */}
                                <Box
                                  sx={{
                                    position: "absolute",
                                    top: 8,
                                    left: 8,
                                    zIndex: 27,
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 0.5,
                                    padding: "3px 8px",
                                    borderRadius: "20px",
                                    background: "rgba(0, 0, 0, 0.7)",
                                    backdropFilter: "blur(10px)",
                                    border:
                                      "1px solid rgba(255, 255, 255, 0.1)",
                                  }}
                                >
                                  <Box
                                    sx={{
                                      width: 6,
                                      height: 6,
                                      borderRadius: "50%",
                                      background: "#4CAF50",
                                      animation: "pulse 2s infinite",
                                      "@keyframes pulse": {
                                        "0%": { opacity: 1 },
                                        "50%": { opacity: 0.5 },
                                        "100%": { opacity: 1 },
                                      },
                                    }}
                                  />
                                  <Typography
                                    variant="caption"
                                    sx={{
                                      color: "rgba(255, 255, 255, 0.9)",
                                      fontSize: "9px",
                                      fontWeight: 500,
                                      letterSpacing: "0.3px",
                                    }}
                                  >
                                    You
                                  </Typography>
                                </Box>

                                {/* Video Element */}
                                <video
                                  ref={localVideoRef2}
                                  id="local-video-container-2"
                                  controls={false}
                                  autoPlay
                                  playsInline
                                  muted
                                  style={{
                                    width: "100%",
                                    height: "100%",
                                    objectFit: "cover",
                                    transform: "scaleX(-1)",
                                    borderRadius: "10px",
                                    pointerEvents: "none", // Allow drag through video
                                  }}
                                ></video>
                              </Paper>
                            </ResizableBox>
                          </Draggable>
                        </div>
                      ) : (
                        <></>
                      )
                    ) : null}
                  </>
                ) : (
                  <>
                    <div
                      className={`no_chat ${
                        show_select_conversation_div ? "display_none" : ""
                      }`}
                    >
                      <h1>Welcome</h1>
                      <span>Please select a user to see conversation</span>
                      <Image
                        src={ConversationIcon}
                        alt=""
                        className="img-fluid"
                      />
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Chat;
